// @ts-nocheck
import { QueryObject, QGuidPath, QBooleanPath, QDateTimeOffsetPath, QStringPath, QNumberPath, QEnumPath, QEntityCollectionPath, QId, QGuidParam, QEntityPath, QCollectionPath, QStringCollection, QGuidCollection, QFunction, OperationReturnType, ReturnTypes, QComplexParam, QAction } from "@odata2ts/odata-query-objects";
import type { LogMessageCatalogId, LogMessageCatalogParametersId, LogMessageCatalogLanguagesId, FileId, FolderId, SegregationTagId, EquipmentLevelId, EquipmentStateMachineId, EquipmentTypeStateMachineId, EquipmentConfigurationStateMachineId, EquipmentPropertyAttributeId, EquipmentTypePropertyAttributeId, EquipmentConfigurationPropertyAttributeId, EquipmentGraphTypeId, EquipmentGroupId, EquipmentGraphNodeId, EquipmentGraphLinkId, EquipmentGraphNodeConfigurationId, EquipmentGraphLinkConfigurationId, EquipmentGraphConfigurationId, EquipmentGroupConfigurationId, StatusTransitionId, StatusId, StateMachineId, EquipmentPropertyId, EquipmentId, EquipmentTypePropertyId, EquipmentTypeId, EquipmentConfigurationPropertyId, EquipmentConfigurationId, EquipmentLevelFacetId, EquipmentStateMachineFacetId, EquipmentTypeStateMachineFacetId, EquipmentConfigurationStateMachineFacetId, EquipmentPropertyAttributeFacetId, EquipmentTypePropertyAttributeFacetId, EquipmentConfigurationPropertyAttributeFacetId, EquipmentGraphTypeFacetId, EquipmentGroupFacetId, EquipmentGraphNodeFacetId, EquipmentGraphLinkFacetId, EquipmentGraphNodeConfigurationFacetId, EquipmentGraphLinkConfigurationFacetId, EquipmentGraphConfigurationFacetId, EquipmentGroupConfigurationFacetId, StatusTransitionFacetId, StatusFacetId, StateMachineFacetId, EquipmentPropertyFacetId, EquipmentFacetId, EquipmentTypePropertyFacetId, EquipmentTypeFacetId, EquipmentConfigurationPropertyFacetId, EquipmentConfigurationFacetId, OPCUAConnect_EquipmentToAutomationNodeId, OPCUAConnect_AutomationNodeId, OPCUAConnect_AutomationNodeInstanceId, OPCUAConnect_AutomationNodeTypeId, OPCUAConnect_EquipmentTypeToAutomationNodeTypeId, OPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceId, OPCUAConnect_EquipmentToAutomationNodeFacetId, OPCUAConnect_AutomationNodeFacetId, OPCUAConnect_AutomationNodeInstanceFacetId, OPCUAConnect_AutomationNodeTypeFacetId, OPCUAConnect_EquipmentTypeToAutomationNodeTypeFacetId, OPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacetId, RF_GetEquipmentHierarchy2Params, RF_GetFilteredEquipmentConfigurationList2Params, RF_GetStateMachineList2Params, OPCUAConnect_RF_GetAutomationNodes2Params, GetEquipmentConfigurationsWithFilter2Params, OPCUAConnect_RF_GetAutomationNodeTypes2Params, OPCUAConnect_RF_GetAutomationNodeInstances2Params, DeleteEquipmentLevels2Params, DeleteEquipmentTypes2Params, DeleteEquipmentConfigurations2Params, DeleteEquipmentGroupConfigurations2Params, DeleteEquipmentGraphConfigurations2Params, UpdateEquipmentGraphConfiguration2Params, AssociateChildrenEquipmentGroupConfWithEquipmentGroupConf2Params, AssociateEquipmentConfigurationsWithEquipmentGroupConfiguration2Params, SynchronizeEquipmentGraph2Params, BulkImportEquipmentGraphConfiguration2Params, AddEquipmentTypeStateMachines2Params, CreateEquipmentStateMachines2Params, DeleteEquipmentTypePropertyAttribute2Params, UpdateEquipmentPropertyAttribute2Params, SetEquipmentPropertyValue2Params, UnfreezeEquipmentLevel2Params, FreezeEquipmentType2Params, UpdateEquipmentGraphNode2Params, UpdateEquipmentGraphLink2Params, DeleteEquipmentGroupConfiguration2Params, DisassociateParentsEquipmentGroupConfFromEquipmentGroupConf2Params, DeleteEquipmentTypeProperty2Params, AssociateParentsEquipmentGroupConfWithEquipmentGroupConf2Params, UpdateEquipmentConfiguration2Params, UpdateEquipment2Params, DisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration2Params, AddEquipmentConfigurationStateMachines2Params, DisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration2Params, SetEquipmentTypeAsDefault2Params, SetEquipmentStatus2Params, FreezeEquipmentLevel2Params, DeleteEquipmentStateMachine2Params, UpdateEquipmentType2Params, UpdateEquipmentGraphType2Params, UpdateHierarchyEquipmentNodeConfiguration2Params, CreateEquipmentLevel2Params, CreateEquipmentGroupConfiguration2Params, SynchronizeEquipment2Params, CreateEquipment2Params, UpdateEquipmentTypeProperty2Params, UpdateEquipmentConfigurationProperty2Params, UnfreezeEquipmentGroupConfiguration2Params, CreateEquipmentGraphNodeConfiguration2Params, CreateEquipmentGraphType2Params, DeleteEquipmentGraphType2Params, UpdateEquipmentLevel2Params, UpdateEquipmentTypePropertyAttribute2Params, CreateEquipmentType2Params, CreateEquipmentConfiguration2Params, UpdateEquipmentGraphLinkConfiguration2Params, BulkImportEquipmentHierarchy2Params, ForceEquipmentStatus2Params, SetEquipmentPropertyAttributeValue2Params, DeleteEquipmentLevel2Params, CreateEquipmentGraphLinkConfiguration2Params, FreezeEquipmentConfiguration2Params, DeleteHierarchyEquipmentNodeConfiguration2Params, UpdateEquipmentGroup2Params, CreateHierarchyEquipmentNodeConfigurations2Params, SynchronizeEquipmentGroup2Params, DeleteEquipmentTypeStateMachine2Params, CreateEquipmentGraphConfiguration2Params, UnfreezeEquipmentConfiguration2Params, DeleteEquipmentType2Params, FreezeEquipment2Params, AssociateEquipmentGroupConfigurationsWithEquipmentConfiguration2Params, CreateEquipmentConfigurationByDefaultEquipmentType2Params, UpdateEquipmentProperty2Params, UpdateEquipmentGroupConfiguration2Params, DeleteEquipmentConfigurationPropertyAttribute2Params, DeleteEquipmentConfigurationStateMachine2Params, DeleteEquipmentGraphConfiguration2Params, DeleteEquipment2Params, FreezeEquipmentGroupConfiguration2Params, DeleteEquipmentGraphLinkConfiguration2Params, DeleteEquipmentPropertyAttribute2Params, DeleteEquipmentConfiguration2Params, DeleteEquipmentConfigurationProperty2Params, UnfreezeEquipmentType2Params, DisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf2Params, UpdateEquipmentConfigurationPropertyAttribute2Params, UnfreezeEquipment2Params, DeleteEquipmentGraphNodeConfiguration2Params, OPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes2Params, OPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration2Params, OPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration2Params, OPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType2Params, OPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType2Params, SetEquipmentGraphConfigurationAsDefault2Params } from "./EquipmentModel";
import { ApplicationLogLevelType, SegregationTagStatus, SupportedTypes, StatusesOutcome, TagSmoothingMode, TagAcquisitionMode, TagAddressType } from "./EquipmentModel";

export class QLogMessageCatalog extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Owner = new QStringPath(this.withPrefix("Owner"));
    public readonly LanguageCode = new QStringPath(this.withPrefix("LanguageCode"));
    public readonly ShortMessage = new QStringPath(this.withPrefix("ShortMessage"));
    public readonly LongMessage = new QStringPath(this.withPrefix("LongMessage"));
    public readonly MessageId = new QNumberPath(this.withPrefix("MessageId"));
    public readonly Level = new QEnumPath(this.withPrefix("Level"), ApplicationLogLevelType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalogParameters = new QEntityCollectionPath(this.withPrefix("LogMessageCatalogParameters"), () => QLogMessageCatalogParameters);
    public readonly LogMessageCatalogLanguages = new QEntityCollectionPath(this.withPrefix("LogMessageCatalogLanguages"), () => QLogMessageCatalogLanguages);
}

export const qLogMessageCatalog = new QLogMessageCatalog();

export class QLogMessageCatalogId extends QId<LogMessageCatalogId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogMessageCatalogParameters extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly ParameterKey = new QStringPath(this.withPrefix("ParameterKey"));
    public readonly ParameterType = new QStringPath(this.withPrefix("ParameterType"));
    public readonly LogMessageCatalog_Id = new QGuidPath(this.withPrefix("LogMessageCatalog_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalog = new QEntityPath(this.withPrefix("LogMessageCatalog"), () => QLogMessageCatalog);
}

export const qLogMessageCatalogParameters = new QLogMessageCatalogParameters();

export class QLogMessageCatalogParametersId extends QId<LogMessageCatalogParametersId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QLogMessageCatalogLanguages extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly LanguageCode = new QStringPath(this.withPrefix("LanguageCode"));
    public readonly ShortMessage = new QStringPath(this.withPrefix("ShortMessage"));
    public readonly LongMessage = new QStringPath(this.withPrefix("LongMessage"));
    public readonly LogMessageCatalog_Id = new QGuidPath(this.withPrefix("LogMessageCatalog_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly LogMessageCatalog = new QEntityPath(this.withPrefix("LogMessageCatalog"), () => QLogMessageCatalog);
}

export const qLogMessageCatalogLanguages = new QLogMessageCatalogLanguages();

export class QLogMessageCatalogLanguagesId extends QId<LogMessageCatalogLanguagesId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFile extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly PayloadSize = new QNumberPath(this.withPrefix("PayloadSize"));
    public readonly CreatedBy = new QStringPath(this.withPrefix("CreatedBy"));
    public readonly LastUpdatedBy = new QStringPath(this.withPrefix("LastUpdatedBy"));
    public readonly Folder_Id = new QGuidPath(this.withPrefix("Folder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Folder = new QEntityPath(this.withPrefix("Folder"), () => QFolder);
}

export const qFile = new QFile();

export class QFileId extends QId<FileId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QFolder extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly ParentFolder_Id = new QGuidPath(this.withPrefix("ParentFolder_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly ParentFolder = new QEntityPath(this.withPrefix("ParentFolder"), () => QFolder);
}

export const qFolder = new QFolder();

export class QFolderId extends QId<FolderId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QSegregationTag extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly TagStatus = new QEnumPath(this.withPrefix("TagStatus"), SegregationTagStatus);
    public readonly IsLogRelevant = new QBooleanPath(this.withPrefix("IsLogRelevant"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
}

export const qSegregationTag = new QSegregationTag();

export class QSegregationTagId extends QId<SegregationTagId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentLevel extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentLevelFacet);
}

export const qEquipmentLevel = new QEquipmentLevel();

export class QEquipmentLevelId extends QId<EquipmentLevelId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Equipment_Id = new QGuidPath(this.withPrefix("Equipment_Id"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityPath(this.withPrefix("Equipment"), () => QEquipment);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentStateMachineFacet);
}

export const qEquipmentStateMachine = new QEquipmentStateMachine();

export class QEquipmentStateMachineId extends QId<EquipmentStateMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypeStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly EquipmentType_Id = new QGuidPath(this.withPrefix("EquipmentType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentType = new QEntityPath(this.withPrefix("EquipmentType"), () => QEquipmentType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentTypeStateMachineFacet);
}

export const qEquipmentTypeStateMachine = new QEquipmentTypeStateMachine();

export class QEquipmentTypeStateMachineId extends QId<EquipmentTypeStateMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly EquipmentConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfiguration = new QEntityPath(this.withPrefix("EquipmentConfiguration"), () => QEquipmentConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentConfigurationStateMachineFacet);
}

export const qEquipmentConfigurationStateMachine = new QEquipmentConfigurationStateMachine();

export class QEquipmentConfigurationStateMachineId extends QId<EquipmentConfigurationStateMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentPropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly AttributeValue = new QStringPath(this.withPrefix("AttributeValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly AttributeType = new QEnumPath(this.withPrefix("AttributeType"), SupportedTypes);
    public readonly EquipmentProperty_Id = new QGuidPath(this.withPrefix("EquipmentProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentProperty = new QEntityPath(this.withPrefix("EquipmentProperty"), () => QEquipmentProperty);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentPropertyAttributeFacet);
}

export const qEquipmentPropertyAttribute = new QEquipmentPropertyAttribute();

export class QEquipmentPropertyAttributeId extends QId<EquipmentPropertyAttributeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypePropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly AttributeValue = new QStringPath(this.withPrefix("AttributeValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly AttributeType = new QEnumPath(this.withPrefix("AttributeType"), SupportedTypes);
    public readonly EquipmentTypeProperty_Id = new QGuidPath(this.withPrefix("EquipmentTypeProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentTypeProperty = new QEntityPath(this.withPrefix("EquipmentTypeProperty"), () => QEquipmentTypeProperty);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentTypePropertyAttributeFacet);
}

export const qEquipmentTypePropertyAttribute = new QEquipmentTypePropertyAttribute();

export class QEquipmentTypePropertyAttributeId extends QId<EquipmentTypePropertyAttributeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationPropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly AttributeValue = new QStringPath(this.withPrefix("AttributeValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly AttributeType = new QEnumPath(this.withPrefix("AttributeType"), SupportedTypes);
    public readonly EquipmentConfigurationProperty_Id = new QGuidPath(this.withPrefix("EquipmentConfigurationProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurationProperty = new QEntityPath(this.withPrefix("EquipmentConfigurationProperty"), () => QEquipmentConfigurationProperty);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentConfigurationPropertyAttributeFacet);
}

export const qEquipmentConfigurationPropertyAttribute = new QEquipmentConfigurationPropertyAttribute();

export class QEquipmentConfigurationPropertyAttributeId extends QId<EquipmentConfigurationPropertyAttributeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphTypeFacet);
}

export const qEquipmentGraphType = new QEquipmentGraphType();

export class QEquipmentGraphTypeId extends QId<EquipmentGraphTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGroup extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentGroupConfigurationId = new QGuidPath(this.withPrefix("EquipmentGroupConfigurationId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityCollectionPath(this.withPrefix("Equipment"), () => QEquipment);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGroupFacet);
}

export const qEquipmentGroup = new QEquipmentGroup();

export class QEquipmentGroupId extends QId<EquipmentGroupId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphNode extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphConfigurationNId = new QStringPath(this.withPrefix("EquipmentGraphConfigurationNId"));
    public readonly EquipmentGraphType = new QStringPath(this.withPrefix("EquipmentGraphType"));
    public readonly EquipmentGroupNId = new QStringPath(this.withPrefix("EquipmentGroupNId"));
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
    public readonly EquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphNodeConfigurationId"));
    public readonly OffsetX = new QNumberPath(this.withPrefix("OffsetX"));
    public readonly OffsetY = new QNumberPath(this.withPrefix("OffsetY"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphNodeFacet);
}

export const qEquipmentGraphNode = new QEquipmentGraphNode();

export class QEquipmentGraphNodeId extends QId<EquipmentGraphNodeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphLink extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly SourcePosition = new QStringPath(this.withPrefix("SourcePosition"));
    public readonly DestinationPosition = new QStringPath(this.withPrefix("DestinationPosition"));
    public readonly EquipmentGraphLinkConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphLinkConfigurationId"));
    public readonly Source_Id = new QGuidPath(this.withPrefix("Source_Id"));
    public readonly Destination_Id = new QGuidPath(this.withPrefix("Destination_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Source = new QEntityPath(this.withPrefix("Source"), () => QEquipmentGraphNode);
    public readonly Destination = new QEntityPath(this.withPrefix("Destination"), () => QEquipmentGraphNode);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphLinkFacet);
}

export const qEquipmentGraphLink = new QEquipmentGraphLink();

export class QEquipmentGraphLinkId extends QId<EquipmentGraphLinkId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphNodeConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfigurationNId = new QStringPath(this.withPrefix("EquipmentConfigurationNId"));
    public readonly EquipmentGroupConfigurationNId = new QStringPath(this.withPrefix("EquipmentGroupConfigurationNId"));
    public readonly OffsetX = new QNumberPath(this.withPrefix("OffsetX"));
    public readonly OffsetY = new QNumberPath(this.withPrefix("OffsetY"));
    public readonly EquipmentGraphConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentGraphConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphConfiguration = new QEntityPath(this.withPrefix("EquipmentGraphConfiguration"), () => QEquipmentGraphConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphNodeConfigurationFacet);
}

export const qEquipmentGraphNodeConfiguration = new QEquipmentGraphNodeConfiguration();

export class QEquipmentGraphNodeConfigurationId extends QId<EquipmentGraphNodeConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphLinkConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly SourcePosition = new QStringPath(this.withPrefix("SourcePosition"));
    public readonly DestinationPosition = new QStringPath(this.withPrefix("DestinationPosition"));
    public readonly Source_Id = new QGuidPath(this.withPrefix("Source_Id"));
    public readonly Destination_Id = new QGuidPath(this.withPrefix("Destination_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Source = new QEntityPath(this.withPrefix("Source"), () => QEquipmentGraphNodeConfiguration);
    public readonly Destination = new QEntityPath(this.withPrefix("Destination"), () => QEquipmentGraphNodeConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphLinkConfigurationFacet);
}

export const qEquipmentGraphLinkConfiguration = new QEquipmentGraphLinkConfiguration();

export class QEquipmentGraphLinkConfigurationId extends QId<EquipmentGraphLinkConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly Type_Id = new QGuidPath(this.withPrefix("Type_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Type = new QEntityPath(this.withPrefix("Type"), () => QEquipmentGraphType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGraphConfigurationFacet);
}

export const qEquipmentGraphConfiguration = new QEquipmentGraphConfiguration();

export class QEquipmentGraphConfigurationId extends QId<EquipmentGraphConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGroupConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurations = new QEntityCollectionPath(this.withPrefix("EquipmentConfigurations"), () => QEquipmentConfiguration);
    public readonly EquipmentGroupConfigurationParents = new QEntityCollectionPath(this.withPrefix("EquipmentGroupConfigurationParents"), () => QEquipmentGroupConfiguration);
    public readonly EquipmentGroupConfigurationChildren = new QEntityCollectionPath(this.withPrefix("EquipmentGroupConfigurationChildren"), () => QEquipmentGroupConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentGroupConfigurationFacet);
}

export const qEquipmentGroupConfiguration = new QEquipmentGroupConfiguration();

export class QEquipmentGroupConfigurationId extends QId<EquipmentGroupConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusTransition extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Verb = new QStringPath(this.withPrefix("Verb"));
    public readonly DoRaiseEvent = new QBooleanPath(this.withPrefix("DoRaiseEvent"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly TargetStatus_Id = new QGuidPath(this.withPrefix("TargetStatus_Id"));
    public readonly SourceStatus_Id = new QGuidPath(this.withPrefix("SourceStatus_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly TargetStatus = new QEntityPath(this.withPrefix("TargetStatus"), () => QStatus);
    public readonly SourceStatus = new QEntityPath(this.withPrefix("SourceStatus"), () => QStatus);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStatusTransitionFacet);
}

export const qStatusTransition = new QStatusTransition();

export class QStatusTransitionId extends QId<StatusTransitionId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Color = new QStringPath(this.withPrefix("Color"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly IsInitial = new QBooleanPath(this.withPrefix("IsInitial"));
    public readonly Outcome = new QEnumPath(this.withPrefix("Outcome"), StatusesOutcome);
    public readonly StateMachine_Id = new QGuidPath(this.withPrefix("StateMachine_Id"));
    public readonly SourceStatusTransitions = new QEntityCollectionPath(this.withPrefix("SourceStatusTransitions"), () => QStatusTransition);
    public readonly TargetStatusTransitions = new QEntityCollectionPath(this.withPrefix("TargetStatusTransitions"), () => QStatusTransition);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StateMachine = new QEntityPath(this.withPrefix("StateMachine"), () => QStateMachine);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStatusFacet);
}

export const qStatus = new QStatus();

export class QStatusId extends QId<StatusId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStateMachine extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsHidden = new QBooleanPath(this.withPrefix("IsHidden"));
    public readonly IsSystemDefined = new QBooleanPath(this.withPrefix("IsSystemDefined"));
    public readonly Statuses = new QEntityCollectionPath(this.withPrefix("Statuses"), () => QStatus);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QStateMachineFacet);
}

export const qStateMachine = new QStateMachine();

export class QStateMachineId extends QId<StateMachineId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly Equipment_Id = new QGuidPath(this.withPrefix("Equipment_Id"));
    public readonly EquipmentPropertyAttributes = new QEntityCollectionPath(this.withPrefix("EquipmentPropertyAttributes"), () => QEquipmentPropertyAttribute);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityPath(this.withPrefix("Equipment"), () => QEquipment);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentPropertyFacet);
}

export const qEquipmentProperty = new QEquipmentProperty();

export class QEquipmentPropertyId extends QId<EquipmentPropertyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipment extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly WorkCalendarNId = new QStringPath(this.withPrefix("WorkCalendarNId"));
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatusType);
    public readonly StateMachines = new QEntityCollectionPath(this.withPrefix("StateMachines"), () => QEquipmentStateMachine);
    public readonly EquipmentGroups = new QEntityCollectionPath(this.withPrefix("EquipmentGroups"), () => QEquipmentGroup);
    public readonly EquipmentProperties = new QEntityCollectionPath(this.withPrefix("EquipmentProperties"), () => QEquipmentProperty);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentFacet);
}

export const qEquipment = new QEquipment();

export class QEquipmentId extends QId<EquipmentId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypeProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly EquipmentType_Id = new QGuidPath(this.withPrefix("EquipmentType_Id"));
    public readonly EquipmentTypePropertyAttributes = new QEntityCollectionPath(this.withPrefix("EquipmentTypePropertyAttributes"), () => QEquipmentTypePropertyAttribute);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentType = new QEntityPath(this.withPrefix("EquipmentType"), () => QEquipmentType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentTypePropertyFacet);
}

export const qEquipmentTypeProperty = new QEquipmentTypeProperty();

export class QEquipmentTypePropertyId extends QId<EquipmentTypePropertyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly IsDefault = new QBooleanPath(this.withPrefix("IsDefault"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly StateMachines = new QEntityCollectionPath(this.withPrefix("StateMachines"), () => QEquipmentTypeStateMachine);
    public readonly EquipmentTypeProperties = new QEntityCollectionPath(this.withPrefix("EquipmentTypeProperties"), () => QEquipmentTypeProperty);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentTypeFacet);
}

export const qEquipmentType = new QEquipmentType();

export class QEquipmentTypeId extends QId<EquipmentTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly EquipmentConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentConfiguration_Id"));
    public readonly EquipmentConfigurationPropertyAttributes = new QEntityCollectionPath(this.withPrefix("EquipmentConfigurationPropertyAttributes"), () => QEquipmentConfigurationPropertyAttribute);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfiguration = new QEntityPath(this.withPrefix("EquipmentConfiguration"), () => QEquipmentConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentConfigurationPropertyFacet);
}

export const qEquipmentConfigurationProperty = new QEquipmentConfigurationProperty();

export class QEquipmentConfigurationPropertyId extends QId<EquipmentConfigurationPropertyId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly StateMachines = new QEntityCollectionPath(this.withPrefix("StateMachines"), () => QEquipmentConfigurationStateMachine);
    public readonly EquipmentGroupConfigurations = new QEntityCollectionPath(this.withPrefix("EquipmentGroupConfigurations"), () => QEquipmentGroupConfiguration);
    public readonly EquipmentConfigurationProperties = new QEntityCollectionPath(this.withPrefix("EquipmentConfigurationProperties"), () => QEquipmentConfigurationProperty);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QEquipmentConfigurationFacet);
}

export const qEquipmentConfiguration = new QEquipmentConfiguration();

export class QEquipmentConfigurationId extends QId<EquipmentConfigurationId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentLevelFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentLevel_Id = new QGuidPath(this.withPrefix("EquipmentLevel_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentLevel = new QEntityPath(this.withPrefix("EquipmentLevel"), () => QEquipmentLevel);
}

export const qEquipmentLevelFacet = new QEquipmentLevelFacet();

export class QEquipmentLevelFacetId extends QId<EquipmentLevelFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentStateMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentStateMachine_Id = new QGuidPath(this.withPrefix("EquipmentStateMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentStateMachine = new QEntityPath(this.withPrefix("EquipmentStateMachine"), () => QEquipmentStateMachine);
}

export const qEquipmentStateMachineFacet = new QEquipmentStateMachineFacet();

export class QEquipmentStateMachineFacetId extends QId<EquipmentStateMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypeStateMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentTypeStateMachine_Id = new QGuidPath(this.withPrefix("EquipmentTypeStateMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentTypeStateMachine = new QEntityPath(this.withPrefix("EquipmentTypeStateMachine"), () => QEquipmentTypeStateMachine);
}

export const qEquipmentTypeStateMachineFacet = new QEquipmentTypeStateMachineFacet();

export class QEquipmentTypeStateMachineFacetId extends QId<EquipmentTypeStateMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationStateMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfigurationStateMachine_Id = new QGuidPath(this.withPrefix("EquipmentConfigurationStateMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurationStateMachine = new QEntityPath(this.withPrefix("EquipmentConfigurationStateMachine"), () => QEquipmentConfigurationStateMachine);
}

export const qEquipmentConfigurationStateMachineFacet = new QEquipmentConfigurationStateMachineFacet();

export class QEquipmentConfigurationStateMachineFacetId extends QId<EquipmentConfigurationStateMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentPropertyAttributeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentPropertyAttribute_Id = new QGuidPath(this.withPrefix("EquipmentPropertyAttribute_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentPropertyAttribute = new QEntityPath(this.withPrefix("EquipmentPropertyAttribute"), () => QEquipmentPropertyAttribute);
}

export const qEquipmentPropertyAttributeFacet = new QEquipmentPropertyAttributeFacet();

export class QEquipmentPropertyAttributeFacetId extends QId<EquipmentPropertyAttributeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypePropertyAttributeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentTypePropertyAttribute_Id = new QGuidPath(this.withPrefix("EquipmentTypePropertyAttribute_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentTypePropertyAttribute = new QEntityPath(this.withPrefix("EquipmentTypePropertyAttribute"), () => QEquipmentTypePropertyAttribute);
}

export const qEquipmentTypePropertyAttributeFacet = new QEquipmentTypePropertyAttributeFacet();

export class QEquipmentTypePropertyAttributeFacetId extends QId<EquipmentTypePropertyAttributeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationPropertyAttributeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfigurationPropertyAttribute_Id = new QGuidPath(this.withPrefix("EquipmentConfigurationPropertyAttribute_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurationPropertyAttribute = new QEntityPath(this.withPrefix("EquipmentConfigurationPropertyAttribute"), () => QEquipmentConfigurationPropertyAttribute);
}

export const qEquipmentConfigurationPropertyAttributeFacet = new QEquipmentConfigurationPropertyAttributeFacet();

export class QEquipmentConfigurationPropertyAttributeFacetId extends QId<EquipmentConfigurationPropertyAttributeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphType_Id = new QGuidPath(this.withPrefix("EquipmentGraphType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphType = new QEntityPath(this.withPrefix("EquipmentGraphType"), () => QEquipmentGraphType);
}

export const qEquipmentGraphTypeFacet = new QEquipmentGraphTypeFacet();

export class QEquipmentGraphTypeFacetId extends QId<EquipmentGraphTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGroupFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGroup_Id = new QGuidPath(this.withPrefix("EquipmentGroup_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGroup = new QEntityPath(this.withPrefix("EquipmentGroup"), () => QEquipmentGroup);
}

export const qEquipmentGroupFacet = new QEquipmentGroupFacet();

export class QEquipmentGroupFacetId extends QId<EquipmentGroupFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphNodeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphNode_Id = new QGuidPath(this.withPrefix("EquipmentGraphNode_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphNode = new QEntityPath(this.withPrefix("EquipmentGraphNode"), () => QEquipmentGraphNode);
}

export const qEquipmentGraphNodeFacet = new QEquipmentGraphNodeFacet();

export class QEquipmentGraphNodeFacetId extends QId<EquipmentGraphNodeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphLinkFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphLink_Id = new QGuidPath(this.withPrefix("EquipmentGraphLink_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphLink = new QEntityPath(this.withPrefix("EquipmentGraphLink"), () => QEquipmentGraphLink);
}

export const qEquipmentGraphLinkFacet = new QEquipmentGraphLinkFacet();

export class QEquipmentGraphLinkFacetId extends QId<EquipmentGraphLinkFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphNodeConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphNodeConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentGraphNodeConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphNodeConfiguration = new QEntityPath(this.withPrefix("EquipmentGraphNodeConfiguration"), () => QEquipmentGraphNodeConfiguration);
}

export const qEquipmentGraphNodeConfigurationFacet = new QEquipmentGraphNodeConfigurationFacet();

export class QEquipmentGraphNodeConfigurationFacetId extends QId<EquipmentGraphNodeConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphLinkConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphLinkConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentGraphLinkConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphLinkConfiguration = new QEntityPath(this.withPrefix("EquipmentGraphLinkConfiguration"), () => QEquipmentGraphLinkConfiguration);
}

export const qEquipmentGraphLinkConfigurationFacet = new QEquipmentGraphLinkConfigurationFacet();

export class QEquipmentGraphLinkConfigurationFacetId extends QId<EquipmentGraphLinkConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGraphConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGraphConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentGraphConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGraphConfiguration = new QEntityPath(this.withPrefix("EquipmentGraphConfiguration"), () => QEquipmentGraphConfiguration);
}

export const qEquipmentGraphConfigurationFacet = new QEquipmentGraphConfigurationFacet();

export class QEquipmentGraphConfigurationFacetId extends QId<EquipmentGraphConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentGroupConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentGroupConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentGroupConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentGroupConfiguration = new QEntityPath(this.withPrefix("EquipmentGroupConfiguration"), () => QEquipmentGroupConfiguration);
}

export const qEquipmentGroupConfigurationFacet = new QEquipmentGroupConfigurationFacet();

export class QEquipmentGroupConfigurationFacetId extends QId<EquipmentGroupConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusTransitionFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StatusTransition_Id = new QGuidPath(this.withPrefix("StatusTransition_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StatusTransition = new QEntityPath(this.withPrefix("StatusTransition"), () => QStatusTransition);
}

export const qStatusTransitionFacet = new QStatusTransitionFacet();

export class QStatusTransitionFacetId extends QId<StatusTransitionFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStatusFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Status_Id = new QGuidPath(this.withPrefix("Status_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Status = new QEntityPath(this.withPrefix("Status"), () => QStatus);
}

export const qStatusFacet = new QStatusFacet();

export class QStatusFacetId extends QId<StatusFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QStateMachineFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly StateMachine_Id = new QGuidPath(this.withPrefix("StateMachine_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly StateMachine = new QEntityPath(this.withPrefix("StateMachine"), () => QStateMachine);
}

export const qStateMachineFacet = new QStateMachineFacet();

export class QStateMachineFacetId extends QId<StateMachineFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentPropertyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentProperty_Id = new QGuidPath(this.withPrefix("EquipmentProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentProperty = new QEntityPath(this.withPrefix("EquipmentProperty"), () => QEquipmentProperty);
}

export const qEquipmentPropertyFacet = new QEquipmentPropertyFacet();

export class QEquipmentPropertyFacetId extends QId<EquipmentPropertyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Equipment_Id = new QGuidPath(this.withPrefix("Equipment_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityPath(this.withPrefix("Equipment"), () => QEquipment);
}

export const qEquipmentFacet = new QEquipmentFacet();

export class QEquipmentFacetId extends QId<EquipmentFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypePropertyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentTypeProperty_Id = new QGuidPath(this.withPrefix("EquipmentTypeProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentTypeProperty = new QEntityPath(this.withPrefix("EquipmentTypeProperty"), () => QEquipmentTypeProperty);
}

export const qEquipmentTypePropertyFacet = new QEquipmentTypePropertyFacet();

export class QEquipmentTypePropertyFacetId extends QId<EquipmentTypePropertyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentType_Id = new QGuidPath(this.withPrefix("EquipmentType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentType = new QEntityPath(this.withPrefix("EquipmentType"), () => QEquipmentType);
}

export const qEquipmentTypeFacet = new QEquipmentTypeFacet();

export class QEquipmentTypeFacetId extends QId<EquipmentTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationPropertyFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfigurationProperty_Id = new QGuidPath(this.withPrefix("EquipmentConfigurationProperty_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfigurationProperty = new QEntityPath(this.withPrefix("EquipmentConfigurationProperty"), () => QEquipmentConfigurationProperty);
}

export const qEquipmentConfigurationPropertyFacet = new QEquipmentConfigurationPropertyFacet();

export class QEquipmentConfigurationPropertyFacetId extends QId<EquipmentConfigurationPropertyFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QEquipmentConfigurationFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly EquipmentConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfiguration = new QEntityPath(this.withPrefix("EquipmentConfiguration"), () => QEquipmentConfiguration);
}

export const qEquipmentConfigurationFacet = new QEquipmentConfigurationFacet();

export class QEquipmentConfigurationFacetId extends QId<EquipmentConfigurationFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_EquipmentToAutomationNode extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeNId = new QStringPath(this.withPrefix("AutomationNodeNId"));
    public readonly Equipment_Id = new QGuidPath(this.withPrefix("Equipment_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Equipment = new QEntityPath(this.withPrefix("Equipment"), () => QEquipment);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOPCUAConnect_EquipmentToAutomationNodeFacet);
}

export const qOPCUAConnect_EquipmentToAutomationNode = new QOPCUAConnect_EquipmentToAutomationNode();

export class QOPCUAConnect_EquipmentToAutomationNodeId extends QId<OPCUAConnect_EquipmentToAutomationNodeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_AutomationNode extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly NodeId = new QStringPath(this.withPrefix("NodeId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly AutomationNodeTypeNId = new QStringPath(this.withPrefix("AutomationNodeTypeNId"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOPCUAConnect_AutomationNodeFacet);
}

export const qOPCUAConnect_AutomationNode = new QOPCUAConnect_AutomationNode();

export class QOPCUAConnect_AutomationNodeId extends QId<OPCUAConnect_AutomationNodeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_AutomationNodeInstance extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ChannelNId = new QStringPath(this.withPrefix("ChannelNId"));
    public readonly AutomationNodeType_Id = new QGuidPath(this.withPrefix("AutomationNodeType_Id"));
    public readonly ActivationStatus = new QEntityPath(this.withPrefix("ActivationStatus"), () => QActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly AutomationNodeType = new QEntityPath(this.withPrefix("AutomationNodeType"), () => QOPCUAConnect_AutomationNodeType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOPCUAConnect_AutomationNodeInstanceFacet);
}

export const qOPCUAConnect_AutomationNodeInstance = new QOPCUAConnect_AutomationNodeInstance();

export class QOPCUAConnect_AutomationNodeInstanceId extends QId<OPCUAConnect_AutomationNodeInstanceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_AutomationNodeType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly SourceRevision = new QStringPath(this.withPrefix("SourceRevision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly ActivationStatus = new QEntityPath(this.withPrefix("ActivationStatus"), () => QActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types);
    public readonly AutomationNodeInstances = new QEntityCollectionPath(this.withPrefix("AutomationNodeInstances"), () => QOPCUAConnect_AutomationNodeInstance);
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOPCUAConnect_AutomationNodeTypeFacet);
}

export const qOPCUAConnect_AutomationNodeType = new QOPCUAConnect_AutomationNodeType();

export class QOPCUAConnect_AutomationNodeTypeId extends QId<OPCUAConnect_AutomationNodeTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_EquipmentTypeToAutomationNodeType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeTypeNId = new QStringPath(this.withPrefix("AutomationNodeTypeNId"));
    public readonly EquipmentType_Id = new QGuidPath(this.withPrefix("EquipmentType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentType = new QEntityPath(this.withPrefix("EquipmentType"), () => QEquipmentType);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOPCUAConnect_EquipmentTypeToAutomationNodeTypeFacet);
}

export const qOPCUAConnect_EquipmentTypeToAutomationNodeType = new QOPCUAConnect_EquipmentTypeToAutomationNodeType();

export class QOPCUAConnect_EquipmentTypeToAutomationNodeTypeId extends QId<OPCUAConnect_EquipmentTypeToAutomationNodeTypeId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_EquipmentConfigurationToAutomationNodeInstance extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly AutomationNodeInstanceNId = new QStringPath(this.withPrefix("AutomationNodeInstanceNId"));
    public readonly EquipmentConfiguration_Id = new QGuidPath(this.withPrefix("EquipmentConfiguration_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly EquipmentConfiguration = new QEntityPath(this.withPrefix("EquipmentConfiguration"), () => QEquipmentConfiguration);
    public readonly Facets = new QEntityCollectionPath(this.withPrefix("Facets"), () => QOPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacet);
}

export const qOPCUAConnect_EquipmentConfigurationToAutomationNodeInstance = new QOPCUAConnect_EquipmentConfigurationToAutomationNodeInstance();

export class QOPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceId extends QId<OPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_EquipmentToAutomationNodeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OPCUAConnect_EquipmentToAutomationNode_Id = new QGuidPath(this.withPrefix("OPCUAConnect_EquipmentToAutomationNode_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OPCUAConnect_EquipmentToAutomationNode = new QEntityPath(this.withPrefix("OPCUAConnect_EquipmentToAutomationNode"), () => QOPCUAConnect_EquipmentToAutomationNode);
}

export const qOPCUAConnect_EquipmentToAutomationNodeFacet = new QOPCUAConnect_EquipmentToAutomationNodeFacet();

export class QOPCUAConnect_EquipmentToAutomationNodeFacetId extends QId<OPCUAConnect_EquipmentToAutomationNodeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_AutomationNodeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OPCUAConnect_AutomationNode_Id = new QGuidPath(this.withPrefix("OPCUAConnect_AutomationNode_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OPCUAConnect_AutomationNode = new QEntityPath(this.withPrefix("OPCUAConnect_AutomationNode"), () => QOPCUAConnect_AutomationNode);
}

export const qOPCUAConnect_AutomationNodeFacet = new QOPCUAConnect_AutomationNodeFacet();

export class QOPCUAConnect_AutomationNodeFacetId extends QId<OPCUAConnect_AutomationNodeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_AutomationNodeInstanceFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OPCUAConnect_AutomationNodeInstance_Id = new QGuidPath(this.withPrefix("OPCUAConnect_AutomationNodeInstance_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OPCUAConnect_AutomationNodeInstance = new QEntityPath(this.withPrefix("OPCUAConnect_AutomationNodeInstance"), () => QOPCUAConnect_AutomationNodeInstance);
}

export const qOPCUAConnect_AutomationNodeInstanceFacet = new QOPCUAConnect_AutomationNodeInstanceFacet();

export class QOPCUAConnect_AutomationNodeInstanceFacetId extends QId<OPCUAConnect_AutomationNodeInstanceFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_AutomationNodeTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OPCUAConnect_AutomationNodeType_Id = new QGuidPath(this.withPrefix("OPCUAConnect_AutomationNodeType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OPCUAConnect_AutomationNodeType = new QEntityPath(this.withPrefix("OPCUAConnect_AutomationNodeType"), () => QOPCUAConnect_AutomationNodeType);
}

export const qOPCUAConnect_AutomationNodeTypeFacet = new QOPCUAConnect_AutomationNodeTypeFacet();

export class QOPCUAConnect_AutomationNodeTypeFacetId extends QId<OPCUAConnect_AutomationNodeTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_EquipmentTypeToAutomationNodeTypeFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OPCUAConnect_EquipmentTypeToAutomationNodeType_Id = new QGuidPath(this.withPrefix("OPCUAConnect_EquipmentTypeToAutomationNodeType_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OPCUAConnect_EquipmentTypeToAutomationNodeType = new QEntityPath(this.withPrefix("OPCUAConnect_EquipmentTypeToAutomationNodeType"), () => QOPCUAConnect_EquipmentTypeToAutomationNodeType);
}

export const qOPCUAConnect_EquipmentTypeToAutomationNodeTypeFacet = new QOPCUAConnect_EquipmentTypeToAutomationNodeTypeFacet();

export class QOPCUAConnect_EquipmentTypeToAutomationNodeTypeFacetId extends QId<OPCUAConnect_EquipmentTypeToAutomationNodeTypeFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacet extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly IsFrozen = new QBooleanPath(this.withPrefix("IsFrozen"));
    public readonly CreatedOn = new QDateTimeOffsetPath(this.withPrefix("CreatedOn"));
    public readonly LastUpdatedOn = new QDateTimeOffsetPath(this.withPrefix("LastUpdatedOn"));
    public readonly EntityType = new QStringPath(this.withPrefix("EntityType"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly ToBeCleaned = new QBooleanPath(this.withPrefix("ToBeCleaned"));
    public readonly OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance_Id = new QGuidPath(this.withPrefix("OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance_Id"));
    public readonly SegregationTags = new QEntityCollectionPath(this.withPrefix("SegregationTags"), () => QSegregationTag);
    public readonly OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance = new QEntityPath(this.withPrefix("OPCUAConnect_EquipmentConfigurationToAutomationNodeInstance"), () => QOPCUAConnect_EquipmentConfigurationToAutomationNodeInstance);
}

export const qOPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacet = new QOPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacet();

export class QOPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacetId extends QId<OPCUAConnect_EquipmentConfigurationToAutomationNodeInstanceFacetId> {
    private readonly params = [new QGuidParam("Id")];

    getParams() {
        return this.params
    }
}

export class QExecutionError extends QueryObject {
    public readonly ErrorCode = new QNumberPath(this.withPrefix("ErrorCode"));
    public readonly ErrorMessage = new QStringPath(this.withPrefix("ErrorMessage"));
}

export const qExecutionError = new QExecutionError();

export class QPrecheckExecution extends QueryObject {
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly FullName = new QStringPath(this.withPrefix("FullName"));
    public readonly Error = new QEntityPath(this.withPrefix("Error"), () => QExecutionError);
}

export const qPrecheckExecution = new QPrecheckExecution();

export class QSitUafExecutionDetail extends QueryObject {
    public readonly PrecheckDetails = new QEntityCollectionPath(this.withPrefix("PrecheckDetails"), () => QPrecheckExecution);
}

export const qSitUafExecutionDetail = new QSitUafExecutionDetail();

export class QCommandResponse extends QueryObject {
    public readonly Succeeded = new QBooleanPath(this.withPrefix("Succeeded"));
    public readonly Error = new QEntityPath(this.withPrefix("Error"), () => QExecutionError);
    public readonly SitUafExecutionDetail = new QEntityPath(this.withPrefix("SitUafExecutionDetail"), () => QSitUafExecutionDetail);
}

export const qCommandResponse = new QCommandResponse();

export class QFunctionResponse extends QCommandResponse {
}

export const qFunctionResponse = new QFunctionResponse();

export class QPreCheckResponse extends QCommandResponse {
}

export const qPreCheckResponse = new QPreCheckResponse();

export class QServiceLayerUnityError extends QueryObject {
    public readonly commandcallstack = new QCollectionPath(this.withPrefix("commandcallstack"), () => QStringCollection);
    public readonly stacktrace = new QStringPath(this.withPrefix("stacktrace"));
}

export const qServiceLayerUnityError = new QServiceLayerUnityError();

export class QServiceLayerErrorObject extends QueryObject {
    public readonly code = new QStringPath(this.withPrefix("code"));
    public readonly message = new QStringPath(this.withPrefix("message"));
    public readonly innererror = new QEntityPath(this.withPrefix("innererror"), () => QServiceLayerUnityError);
}

export const qServiceLayerErrorObject = new QServiceLayerErrorObject();

export class QServiceLayerError extends QueryObject {
    public readonly error = new QEntityPath(this.withPrefix("error"), () => QServiceLayerErrorObject);
}

export const qServiceLayerError = new QServiceLayerError();

export class QDeleteEquipmentLevelsResponse extends QCommandResponse {
    public readonly DeletedEquipmentLevels = new QCollectionPath(this.withPrefix("DeletedEquipmentLevels"), () => QGuidCollection);
    public readonly NotDeletedEquipmentLevels = new QCollectionPath(this.withPrefix("NotDeletedEquipmentLevels"), () => QGuidCollection);
}

export const qDeleteEquipmentLevelsResponse = new QDeleteEquipmentLevelsResponse();

export class QDeleteEquipmentLevels extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteEquipmentLevels = new QDeleteEquipmentLevels();

export class QDeleteEquipmentTypesResponse extends QCommandResponse {
    public readonly DeletedEquipmentTypes = new QCollectionPath(this.withPrefix("DeletedEquipmentTypes"), () => QGuidCollection);
    public readonly NotDeletedEquipmentTypes = new QCollectionPath(this.withPrefix("NotDeletedEquipmentTypes"), () => QGuidCollection);
}

export const qDeleteEquipmentTypesResponse = new QDeleteEquipmentTypesResponse();

export class QDeleteEquipmentTypes extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteEquipmentTypes = new QDeleteEquipmentTypes();

export class QDeleteEquipmentConfigurationsResponse extends QCommandResponse {
    public readonly DeletedEquipmentConfigurations = new QCollectionPath(this.withPrefix("DeletedEquipmentConfigurations"), () => QGuidCollection);
    public readonly NotDeletedEquipmentConfigurations = new QCollectionPath(this.withPrefix("NotDeletedEquipmentConfigurations"), () => QGuidCollection);
}

export const qDeleteEquipmentConfigurationsResponse = new QDeleteEquipmentConfigurationsResponse();

export class QDeleteEquipmentConfigurations extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteEquipmentConfigurations = new QDeleteEquipmentConfigurations();

export class QDeleteEquipmentGroupConfigurationsResponse extends QCommandResponse {
    public readonly DeletedEquipmentGroupConfigurations = new QCollectionPath(this.withPrefix("DeletedEquipmentGroupConfigurations"), () => QGuidCollection);
    public readonly NotDeletedEquipmentGroupConfigurations = new QCollectionPath(this.withPrefix("NotDeletedEquipmentGroupConfigurations"), () => QGuidCollection);
}

export const qDeleteEquipmentGroupConfigurationsResponse = new QDeleteEquipmentGroupConfigurationsResponse();

export class QDeleteEquipmentGroupConfigurations extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteEquipmentGroupConfigurations = new QDeleteEquipmentGroupConfigurations();

export class QDeleteEquipmentGraphConfigurationsResponse extends QCommandResponse {
    public readonly DeletedEquipmentGraphConfigurations = new QCollectionPath(this.withPrefix("DeletedEquipmentGraphConfigurations"), () => QGuidCollection);
    public readonly NotDeletedEquipmentGraphConfigurations = new QCollectionPath(this.withPrefix("NotDeletedEquipmentGraphConfigurations"), () => QGuidCollection);
}

export const qDeleteEquipmentGraphConfigurationsResponse = new QDeleteEquipmentGraphConfigurationsResponse();

export class QDeleteEquipmentGraphConfigurations extends QueryObject {
    public readonly Ids = new QCollectionPath(this.withPrefix("Ids"), () => QGuidCollection);
}

export const qDeleteEquipmentGraphConfigurations = new QDeleteEquipmentGraphConfigurations();

export class QUpdateEquipmentGraphConfigurationResponse extends QCommandResponse {
}

export const qUpdateEquipmentGraphConfigurationResponse = new QUpdateEquipmentGraphConfigurationResponse();

export class QUpdateEquipmentGraphConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateEquipmentGraphConfiguration = new QUpdateEquipmentGraphConfiguration();

export class QAssociateChildrenEquipmentGroupConfWithEquipmentGroupConfResponse extends QCommandResponse {
}

export const qAssociateChildrenEquipmentGroupConfWithEquipmentGroupConfResponse = new QAssociateChildrenEquipmentGroupConfWithEquipmentGroupConfResponse();

export class QAssociateChildrenEquipmentGroupConfWithEquipmentGroupConf extends QueryObject {
    public readonly EquipmentGroupConfId = new QGuidPath(this.withPrefix("EquipmentGroupConfId"));
    public readonly ChildEquipmentGroupConfIds = new QCollectionPath(this.withPrefix("ChildEquipmentGroupConfIds"), () => QGuidCollection);
}

export const qAssociateChildrenEquipmentGroupConfWithEquipmentGroupConf = new QAssociateChildrenEquipmentGroupConfWithEquipmentGroupConf();

export class QAssociateEquipmentConfigurationsWithEquipmentGroupConfigurationResponse extends QCommandResponse {
}

export const qAssociateEquipmentConfigurationsWithEquipmentGroupConfigurationResponse = new QAssociateEquipmentConfigurationsWithEquipmentGroupConfigurationResponse();

export class QAssociateEquipmentConfigurationsWithEquipmentGroupConfiguration extends QueryObject {
    public readonly EquipmentGroupConfigurationId = new QGuidPath(this.withPrefix("EquipmentGroupConfigurationId"));
    public readonly EquipmentConfigurationIds = new QCollectionPath(this.withPrefix("EquipmentConfigurationIds"), () => QGuidCollection);
}

export const qAssociateEquipmentConfigurationsWithEquipmentGroupConfiguration = new QAssociateEquipmentConfigurationsWithEquipmentGroupConfiguration();

export class QSynchronizeEquipmentGraphResponse extends QCommandResponse {
}

export const qSynchronizeEquipmentGraphResponse = new QSynchronizeEquipmentGraphResponse();

export class QSynchronizeEquipmentGraph extends QueryObject {
    public readonly Type = new QStringPath(this.withPrefix("Type"));
}

export const qSynchronizeEquipmentGraph = new QSynchronizeEquipmentGraph();

export class QBulkImportEquipmentGraphConfigurationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qBulkImportEquipmentGraphConfigurationResponse = new QBulkImportEquipmentGraphConfigurationResponse();

export class QBulkImportEquipmentGraphConfiguration extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
    public readonly EquipmentGraphNodeConfigurations = new QEntityCollectionPath(this.withPrefix("EquipmentGraphNodeConfigurations"), () => QEquipmentGraphNodeConfigurationParameterType);
    public readonly EquipmentGraphLinkConfigurations = new QEntityCollectionPath(this.withPrefix("EquipmentGraphLinkConfigurations"), () => QEquipmentGraphLinkConfigurationParameterType);
}

export const qBulkImportEquipmentGraphConfiguration = new QBulkImportEquipmentGraphConfiguration();

export class QAddEquipmentTypeStateMachinesResponse extends QCommandResponse {
    public readonly EquipmentTypeStateMachineIds = new QCollectionPath(this.withPrefix("EquipmentTypeStateMachineIds"), () => QGuidCollection);
}

export const qAddEquipmentTypeStateMachinesResponse = new QAddEquipmentTypeStateMachinesResponse();

export class QAddEquipmentTypeStateMachines extends QueryObject {
    public readonly EquipmentTypeId = new QGuidPath(this.withPrefix("EquipmentTypeId"));
    public readonly StateMachineNIds = new QCollectionPath(this.withPrefix("StateMachineNIds"), () => QStringCollection);
}

export const qAddEquipmentTypeStateMachines = new QAddEquipmentTypeStateMachines();

export class QCreateEquipmentStateMachinesResponse extends QCommandResponse {
    public readonly EquipmentStateMachineIds = new QCollectionPath(this.withPrefix("EquipmentStateMachineIds"), () => QGuidCollection);
}

export const qCreateEquipmentStateMachinesResponse = new QCreateEquipmentStateMachinesResponse();

export class QCreateEquipmentStateMachines extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly EquipmentConfigurationStateMachineIds = new QCollectionPath(this.withPrefix("EquipmentConfigurationStateMachineIds"), () => QGuidCollection);
}

export const qCreateEquipmentStateMachines = new QCreateEquipmentStateMachines();

export class QDeleteEquipmentTypePropertyAttributeResponse extends QCommandResponse {
}

export const qDeleteEquipmentTypePropertyAttributeResponse = new QDeleteEquipmentTypePropertyAttributeResponse();

export class QDeleteEquipmentTypePropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentTypePropertyAttribute = new QDeleteEquipmentTypePropertyAttribute();

export class QUpdateEquipmentPropertyAttributeResponse extends QCommandResponse {
}

export const qUpdateEquipmentPropertyAttributeResponse = new QUpdateEquipmentPropertyAttributeResponse();

export class QUpdateEquipmentPropertyAttribute extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly EquipmentConfigurationPropertyNId = new QStringPath(this.withPrefix("EquipmentConfigurationPropertyNId"));
    public readonly EquipmentConfigurationPropertyAttributeNId = new QStringPath(this.withPrefix("EquipmentConfigurationPropertyAttributeNId"));
    public readonly EquipmentConfigurationPropertyAttributeValue = new QStringPath(this.withPrefix("EquipmentConfigurationPropertyAttributeValue"));
    public readonly EquipmentConfigurationPropertyAttributeOperational = new QBooleanPath(this.withPrefix("EquipmentConfigurationPropertyAttributeOperational"));
}

export const qUpdateEquipmentPropertyAttribute = new QUpdateEquipmentPropertyAttribute();

export class QSetEquipmentPropertyValueResponse extends QCommandResponse {
}

export const qSetEquipmentPropertyValueResponse = new QSetEquipmentPropertyValueResponse();

export class QSetEquipmentPropertyValue extends QueryObject {
    public readonly EquipmentPropertyId = new QGuidPath(this.withPrefix("EquipmentPropertyId"));
    public readonly EquipmentPropertyValue = new QStringPath(this.withPrefix("EquipmentPropertyValue"));
}

export const qSetEquipmentPropertyValue = new QSetEquipmentPropertyValue();

export class QUnfreezeEquipmentLevelResponse extends QCommandResponse {
}

export const qUnfreezeEquipmentLevelResponse = new QUnfreezeEquipmentLevelResponse();

export class QUnfreezeEquipmentLevel extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnfreezeEquipmentLevel = new QUnfreezeEquipmentLevel();

export class QFreezeEquipmentTypeResponse extends QCommandResponse {
}

export const qFreezeEquipmentTypeResponse = new QFreezeEquipmentTypeResponse();

export class QFreezeEquipmentType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qFreezeEquipmentType = new QFreezeEquipmentType();

export class QUpdateEquipmentGraphNodeResponse extends QCommandResponse {
}

export const qUpdateEquipmentGraphNodeResponse = new QUpdateEquipmentGraphNodeResponse();

export class QUpdateEquipmentGraphNode extends QueryObject {
    public readonly EquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphNodeConfigurationId"));
}

export const qUpdateEquipmentGraphNode = new QUpdateEquipmentGraphNode();

export class QUpdateEquipmentGraphLinkResponse extends QCommandResponse {
}

export const qUpdateEquipmentGraphLinkResponse = new QUpdateEquipmentGraphLinkResponse();

export class QUpdateEquipmentGraphLink extends QueryObject {
    public readonly EquipmentGraphLinkConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphLinkConfigurationId"));
}

export const qUpdateEquipmentGraphLink = new QUpdateEquipmentGraphLink();

export class QDeleteEquipmentGroupConfigurationResponse extends QCommandResponse {
}

export const qDeleteEquipmentGroupConfigurationResponse = new QDeleteEquipmentGroupConfigurationResponse();

export class QDeleteEquipmentGroupConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentGroupConfiguration = new QDeleteEquipmentGroupConfiguration();

export class QDisassociateParentsEquipmentGroupConfFromEquipmentGroupConfResponse extends QCommandResponse {
}

export const qDisassociateParentsEquipmentGroupConfFromEquipmentGroupConfResponse = new QDisassociateParentsEquipmentGroupConfFromEquipmentGroupConfResponse();

export class QDisassociateParentsEquipmentGroupConfFromEquipmentGroupConf extends QueryObject {
    public readonly EquipmentGroupConfId = new QGuidPath(this.withPrefix("EquipmentGroupConfId"));
    public readonly ParentEquipmentGroupConfIds = new QCollectionPath(this.withPrefix("ParentEquipmentGroupConfIds"), () => QGuidCollection);
}

export const qDisassociateParentsEquipmentGroupConfFromEquipmentGroupConf = new QDisassociateParentsEquipmentGroupConfFromEquipmentGroupConf();

export class QDeleteEquipmentTypePropertyResponse extends QCommandResponse {
}

export const qDeleteEquipmentTypePropertyResponse = new QDeleteEquipmentTypePropertyResponse();

export class QDeleteEquipmentTypeProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentTypeProperty = new QDeleteEquipmentTypeProperty();

export class QAssociateParentsEquipmentGroupConfWithEquipmentGroupConfResponse extends QCommandResponse {
}

export const qAssociateParentsEquipmentGroupConfWithEquipmentGroupConfResponse = new QAssociateParentsEquipmentGroupConfWithEquipmentGroupConfResponse();

export class QAssociateParentsEquipmentGroupConfWithEquipmentGroupConf extends QueryObject {
    public readonly EquipmentGroupConfId = new QGuidPath(this.withPrefix("EquipmentGroupConfId"));
    public readonly ParentEquipmentGroupConfIds = new QCollectionPath(this.withPrefix("ParentEquipmentGroupConfIds"), () => QGuidCollection);
}

export const qAssociateParentsEquipmentGroupConfWithEquipmentGroupConf = new QAssociateParentsEquipmentGroupConfWithEquipmentGroupConf();

export class QUpdateEquipmentConfigurationResponse extends QCommandResponse {
    public readonly PropertyIds = new QCollectionPath(this.withPrefix("PropertyIds"), () => QGuidCollection);
}

export const qUpdateEquipmentConfigurationResponse = new QUpdateEquipmentConfigurationResponse();

export class QUpdateEquipmentConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly Properties = new QEntityCollectionPath(this.withPrefix("Properties"), () => QPropertyParameterType);
}

export const qUpdateEquipmentConfiguration = new QUpdateEquipmentConfiguration();

export class QUpdateEquipmentResponse extends QCommandResponse {
}

export const qUpdateEquipmentResponse = new QUpdateEquipmentResponse();

export class QUpdateEquipment extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
}

export const qUpdateEquipment = new QUpdateEquipment();

export class QDisassociateEquipmentGroupConfigurationsFromEquipmentConfigurationResponse extends QCommandResponse {
}

export const qDisassociateEquipmentGroupConfigurationsFromEquipmentConfigurationResponse = new QDisassociateEquipmentGroupConfigurationsFromEquipmentConfigurationResponse();

export class QDisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration extends QueryObject {
    public readonly EquipmentGroupConfigurationIds = new QCollectionPath(this.withPrefix("EquipmentGroupConfigurationIds"), () => QGuidCollection);
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
}

export const qDisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration = new QDisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration();

export class QAddEquipmentConfigurationStateMachinesResponse extends QCommandResponse {
    public readonly EquipmentConfigurationStateMachineIds = new QCollectionPath(this.withPrefix("EquipmentConfigurationStateMachineIds"), () => QGuidCollection);
}

export const qAddEquipmentConfigurationStateMachinesResponse = new QAddEquipmentConfigurationStateMachinesResponse();

export class QAddEquipmentConfigurationStateMachines extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly StateMachineNIds = new QCollectionPath(this.withPrefix("StateMachineNIds"), () => QStringCollection);
}

export const qAddEquipmentConfigurationStateMachines = new QAddEquipmentConfigurationStateMachines();

export class QDisassociateEquipmentConfigurationsFromEquipmentGroupConfigurationResponse extends QCommandResponse {
}

export const qDisassociateEquipmentConfigurationsFromEquipmentGroupConfigurationResponse = new QDisassociateEquipmentConfigurationsFromEquipmentGroupConfigurationResponse();

export class QDisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration extends QueryObject {
    public readonly EquipmentGroupConfigurationId = new QGuidPath(this.withPrefix("EquipmentGroupConfigurationId"));
    public readonly EquipmentConfigurationIds = new QCollectionPath(this.withPrefix("EquipmentConfigurationIds"), () => QGuidCollection);
}

export const qDisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration = new QDisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration();

export class QSetEquipmentTypeAsDefaultResponse extends QCommandResponse {
}

export const qSetEquipmentTypeAsDefaultResponse = new QSetEquipmentTypeAsDefaultResponse();

export class QSetEquipmentTypeAsDefault extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qSetEquipmentTypeAsDefault = new QSetEquipmentTypeAsDefault();

export class QSetEquipmentStatusResponse extends QCommandResponse {
}

export const qSetEquipmentStatusResponse = new QSetEquipmentStatusResponse();

export class QSetEquipmentStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Verb = new QStringPath(this.withPrefix("Verb"));
    public readonly EquipmentStateMachineId = new QGuidPath(this.withPrefix("EquipmentStateMachineId"));
}

export const qSetEquipmentStatus = new QSetEquipmentStatus();

export class QFreezeEquipmentLevelResponse extends QCommandResponse {
}

export const qFreezeEquipmentLevelResponse = new QFreezeEquipmentLevelResponse();

export class QFreezeEquipmentLevel extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qFreezeEquipmentLevel = new QFreezeEquipmentLevel();

export class QDeleteEquipmentStateMachineResponse extends QCommandResponse {
}

export const qDeleteEquipmentStateMachineResponse = new QDeleteEquipmentStateMachineResponse();

export class QDeleteEquipmentStateMachine extends QueryObject {
    public readonly EquipmentStateMachineId = new QGuidPath(this.withPrefix("EquipmentStateMachineId"));
}

export const qDeleteEquipmentStateMachine = new QDeleteEquipmentStateMachine();

export class QUpdateEquipmentTypeResponse extends QCommandResponse {
    public readonly PropertyIds = new QCollectionPath(this.withPrefix("PropertyIds"), () => QGuidCollection);
}

export const qUpdateEquipmentTypeResponse = new QUpdateEquipmentTypeResponse();

export class QUpdateEquipmentType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly Properties = new QEntityCollectionPath(this.withPrefix("Properties"), () => QPropertyParameterType);
}

export const qUpdateEquipmentType = new QUpdateEquipmentType();

export class QUpdateEquipmentGraphTypeResponse extends QCommandResponse {
}

export const qUpdateEquipmentGraphTypeResponse = new QUpdateEquipmentGraphTypeResponse();

export class QUpdateEquipmentGraphType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qUpdateEquipmentGraphType = new QUpdateEquipmentGraphType();

export class QUpdateHierarchyEquipmentNodeConfigurationResponse extends QCommandResponse {
}

export const qUpdateHierarchyEquipmentNodeConfigurationResponse = new QUpdateHierarchyEquipmentNodeConfigurationResponse();

export class QUpdateHierarchyEquipmentNodeConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly ParentEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("ParentEquipmentGraphNodeConfigurationId"));
}

export const qUpdateHierarchyEquipmentNodeConfiguration = new QUpdateHierarchyEquipmentNodeConfiguration();

export class QCreateEquipmentLevelResponse extends QCommandResponse {
    public readonly EquipConfLevelId = new QGuidPath(this.withPrefix("EquipConfLevelId"));
}

export const qCreateEquipmentLevelResponse = new QCreateEquipmentLevelResponse();

export class QCreateEquipmentLevel extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
}

export const qCreateEquipmentLevel = new QCreateEquipmentLevel();

export class QCreateEquipmentGroupConfigurationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateEquipmentGroupConfigurationResponse = new QCreateEquipmentGroupConfigurationResponse();

export class QCreateEquipmentGroupConfiguration extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
}

export const qCreateEquipmentGroupConfiguration = new QCreateEquipmentGroupConfiguration();

export class QSynchronizeEquipmentResponse extends QCommandResponse {
}

export const qSynchronizeEquipmentResponse = new QSynchronizeEquipmentResponse();

export class QSynchronizeEquipment extends QueryObject {
    public readonly OverwriteRTValues = new QBooleanPath(this.withPrefix("OverwriteRTValues"));
}

export const qSynchronizeEquipment = new QSynchronizeEquipment();

export class QCreateEquipmentResponse extends QCommandResponse {
    public readonly EquipmentId = new QGuidPath(this.withPrefix("EquipmentId"));
}

export const qCreateEquipmentResponse = new QCreateEquipmentResponse();

export class QCreateEquipment extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
}

export const qCreateEquipment = new QCreateEquipment();

export class QUpdateEquipmentTypePropertyResponse extends QCommandResponse {
    public readonly AttributeIds = new QCollectionPath(this.withPrefix("AttributeIds"), () => QGuidCollection);
}

export const qUpdateEquipmentTypePropertyResponse = new QUpdateEquipmentTypePropertyResponse();

export class QUpdateEquipmentTypeProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Attributes = new QEntityCollectionPath(this.withPrefix("Attributes"), () => QPropertyParameterType);
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qUpdateEquipmentTypeProperty = new QUpdateEquipmentTypeProperty();

export class QUpdateEquipmentConfigurationPropertyResponse extends QCommandResponse {
    public readonly AttributeIds = new QCollectionPath(this.withPrefix("AttributeIds"), () => QGuidCollection);
}

export const qUpdateEquipmentConfigurationPropertyResponse = new QUpdateEquipmentConfigurationPropertyResponse();

export class QUpdateEquipmentConfigurationProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Attributes = new QEntityCollectionPath(this.withPrefix("Attributes"), () => QPropertyParameterType);
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qUpdateEquipmentConfigurationProperty = new QUpdateEquipmentConfigurationProperty();

export class QUnfreezeEquipmentGroupConfigurationResponse extends QCommandResponse {
}

export const qUnfreezeEquipmentGroupConfigurationResponse = new QUnfreezeEquipmentGroupConfigurationResponse();

export class QUnfreezeEquipmentGroupConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnfreezeEquipmentGroupConfiguration = new QUnfreezeEquipmentGroupConfiguration();

export class QCreateEquipmentGraphNodeConfigurationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateEquipmentGraphNodeConfigurationResponse = new QCreateEquipmentGraphNodeConfigurationResponse();

export class QCreateEquipmentGraphNodeConfiguration extends QueryObject {
    public readonly EquipmentGraphConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphConfigurationId"));
    public readonly EquipmentConfigurationNId = new QStringPath(this.withPrefix("EquipmentConfigurationNId"));
    public readonly EquipmentGroupConfigurationNId = new QStringPath(this.withPrefix("EquipmentGroupConfigurationNId"));
    public readonly OffsetX = new QNumberPath(this.withPrefix("OffsetX"));
    public readonly OffsetY = new QNumberPath(this.withPrefix("OffsetY"));
}

export const qCreateEquipmentGraphNodeConfiguration = new QCreateEquipmentGraphNodeConfiguration();

export class QCreateEquipmentGraphTypeResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateEquipmentGraphTypeResponse = new QCreateEquipmentGraphTypeResponse();

export class QCreateEquipmentGraphType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
}

export const qCreateEquipmentGraphType = new QCreateEquipmentGraphType();

export class QDeleteEquipmentGraphTypeResponse extends QCommandResponse {
}

export const qDeleteEquipmentGraphTypeResponse = new QDeleteEquipmentGraphTypeResponse();

export class QDeleteEquipmentGraphType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentGraphType = new QDeleteEquipmentGraphType();

export class QUpdateEquipmentLevelResponse extends QCommandResponse {
}

export const qUpdateEquipmentLevelResponse = new QUpdateEquipmentLevelResponse();

export class QUpdateEquipmentLevel extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Level = new QNumberPath(this.withPrefix("Level"));
}

export const qUpdateEquipmentLevel = new QUpdateEquipmentLevel();

export class QUpdateEquipmentTypePropertyAttributeResponse extends QCommandResponse {
}

export const qUpdateEquipmentTypePropertyAttributeResponse = new QUpdateEquipmentTypePropertyAttributeResponse();

export class QUpdateEquipmentTypePropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly AttributeType = new QEnumPath(this.withPrefix("AttributeType"), SupportedTypes);
    public readonly AttributeValue = new QStringPath(this.withPrefix("AttributeValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qUpdateEquipmentTypePropertyAttribute = new QUpdateEquipmentTypePropertyAttribute();

export class QCreateEquipmentTypeResponse extends QCommandResponse {
    public readonly EquipmentTypeId = new QGuidPath(this.withPrefix("EquipmentTypeId"));
}

export const qCreateEquipmentTypeResponse = new QCreateEquipmentTypeResponse();

export class QCreateEquipmentType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly StateMachineNIds = new QCollectionPath(this.withPrefix("StateMachineNIds"), () => QStringCollection);
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
}

export const qCreateEquipmentType = new QCreateEquipmentType();

export class QCreateEquipmentConfigurationResponse extends QCommandResponse {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
}

export const qCreateEquipmentConfigurationResponse = new QCreateEquipmentConfigurationResponse();

export class QCreateEquipmentConfiguration extends QueryObject {
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentConfigStateMachineNids = new QCollectionPath(this.withPrefix("EquipmentConfigStateMachineNids"), () => QStringCollection);
    public readonly LevelNId = new QStringPath(this.withPrefix("LevelNId"));
    public readonly Properties = new QEntityCollectionPath(this.withPrefix("Properties"), () => QPropertyWithAttributesParameterType);
}

export const qCreateEquipmentConfiguration = new QCreateEquipmentConfiguration();

export class QUpdateEquipmentGraphLinkConfigurationResponse extends QCommandResponse {
}

export const qUpdateEquipmentGraphLinkConfigurationResponse = new QUpdateEquipmentGraphLinkConfigurationResponse();

export class QUpdateEquipmentGraphLinkConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly SourceEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("SourceEquipmentGraphNodeConfigurationId"));
    public readonly DestinationEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("DestinationEquipmentGraphNodeConfigurationId"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly SourcePosition = new QStringPath(this.withPrefix("SourcePosition"));
    public readonly DestinationPosition = new QStringPath(this.withPrefix("DestinationPosition"));
}

export const qUpdateEquipmentGraphLinkConfiguration = new QUpdateEquipmentGraphLinkConfiguration();

export class QBulkImportEquipmentHierarchyResponse extends QCommandResponse {
}

export const qBulkImportEquipmentHierarchyResponse = new QBulkImportEquipmentHierarchyResponse();

export class QBulkImportEquipmentHierarchy extends QueryObject {
    public readonly EquipmentGraphConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphConfigurationId"));
    public readonly Hierarchy = new QStringPath(this.withPrefix("Hierarchy"));
}

export const qBulkImportEquipmentHierarchy = new QBulkImportEquipmentHierarchy();

export class QForceEquipmentStatusResponse extends QCommandResponse {
}

export const qForceEquipmentStatusResponse = new QForceEquipmentStatusResponse();

export class QForceEquipmentStatus extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
    public readonly EquipmentStateMachineId = new QGuidPath(this.withPrefix("EquipmentStateMachineId"));
}

export const qForceEquipmentStatus = new QForceEquipmentStatus();

export class QSetEquipmentPropertyAttributeValueResponse extends QCommandResponse {
}

export const qSetEquipmentPropertyAttributeValueResponse = new QSetEquipmentPropertyAttributeValueResponse();

export class QSetEquipmentPropertyAttributeValue extends QueryObject {
    public readonly EquipmentPropertyAttributeId = new QGuidPath(this.withPrefix("EquipmentPropertyAttributeId"));
    public readonly EquipmentPropertyAttributeValue = new QStringPath(this.withPrefix("EquipmentPropertyAttributeValue"));
}

export const qSetEquipmentPropertyAttributeValue = new QSetEquipmentPropertyAttributeValue();

export class QDeleteEquipmentLevelResponse extends QCommandResponse {
}

export const qDeleteEquipmentLevelResponse = new QDeleteEquipmentLevelResponse();

export class QDeleteEquipmentLevel extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentLevel = new QDeleteEquipmentLevel();

export class QCreateEquipmentGraphLinkConfigurationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateEquipmentGraphLinkConfigurationResponse = new QCreateEquipmentGraphLinkConfigurationResponse();

export class QCreateEquipmentGraphLinkConfiguration extends QueryObject {
    public readonly SourceEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("SourceEquipmentGraphNodeConfigurationId"));
    public readonly DestinationEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("DestinationEquipmentGraphNodeConfigurationId"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly SourcePosition = new QStringPath(this.withPrefix("SourcePosition"));
    public readonly DestinationPosition = new QStringPath(this.withPrefix("DestinationPosition"));
}

export const qCreateEquipmentGraphLinkConfiguration = new QCreateEquipmentGraphLinkConfiguration();

export class QFreezeEquipmentConfigurationResponse extends QCommandResponse {
}

export const qFreezeEquipmentConfigurationResponse = new QFreezeEquipmentConfigurationResponse();

export class QFreezeEquipmentConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qFreezeEquipmentConfiguration = new QFreezeEquipmentConfiguration();

export class QDeleteHierarchyEquipmentNodeConfigurationResponse extends QCommandResponse {
}

export const qDeleteHierarchyEquipmentNodeConfigurationResponse = new QDeleteHierarchyEquipmentNodeConfigurationResponse();

export class QDeleteHierarchyEquipmentNodeConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteHierarchyEquipmentNodeConfiguration = new QDeleteHierarchyEquipmentNodeConfiguration();

export class QUpdateEquipmentGroupResponse extends QCommandResponse {
}

export const qUpdateEquipmentGroupResponse = new QUpdateEquipmentGroupResponse();

export class QUpdateEquipmentGroup extends QueryObject {
    public readonly EquipmentGroupConfigurationId = new QGuidPath(this.withPrefix("EquipmentGroupConfigurationId"));
}

export const qUpdateEquipmentGroup = new QUpdateEquipmentGroup();

export class QCreateHierarchyEquipmentNodeConfigurationsResponse extends QCommandResponse {
    public readonly EquipmentGraphNodeConfigurationIds = new QCollectionPath(this.withPrefix("EquipmentGraphNodeConfigurationIds"), () => QGuidCollection);
}

export const qCreateHierarchyEquipmentNodeConfigurationsResponse = new QCreateHierarchyEquipmentNodeConfigurationsResponse();

export class QCreateHierarchyEquipmentNodeConfigurations extends QueryObject {
    public readonly ParentEquipmentGraphNodeConfigurationId = new QGuidPath(this.withPrefix("ParentEquipmentGraphNodeConfigurationId"));
    public readonly EquipmentConfigurations = new QCollectionPath(this.withPrefix("EquipmentConfigurations"), () => QStringCollection);
    public readonly EquipmentGraphConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphConfigurationId"));
}

export const qCreateHierarchyEquipmentNodeConfigurations = new QCreateHierarchyEquipmentNodeConfigurations();

export class QSynchronizeEquipmentGroupResponse extends QCommandResponse {
}

export const qSynchronizeEquipmentGroupResponse = new QSynchronizeEquipmentGroupResponse();

export class QSynchronizeEquipmentGroup extends QueryObject {
}

export const qSynchronizeEquipmentGroup = new QSynchronizeEquipmentGroup();

export class QDeleteEquipmentTypeStateMachineResponse extends QCommandResponse {
}

export const qDeleteEquipmentTypeStateMachineResponse = new QDeleteEquipmentTypeStateMachineResponse();

export class QDeleteEquipmentTypeStateMachine extends QueryObject {
    public readonly EquipmentTypeId = new QGuidPath(this.withPrefix("EquipmentTypeId"));
    public readonly EquipmentTypeStateMachineId = new QGuidPath(this.withPrefix("EquipmentTypeStateMachineId"));
}

export const qDeleteEquipmentTypeStateMachine = new QDeleteEquipmentTypeStateMachine();

export class QCreateEquipmentGraphConfigurationResponse extends QCommandResponse {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qCreateEquipmentGraphConfigurationResponse = new QCreateEquipmentGraphConfigurationResponse();

export class QCreateEquipmentGraphConfiguration extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Type = new QStringPath(this.withPrefix("Type"));
}

export const qCreateEquipmentGraphConfiguration = new QCreateEquipmentGraphConfiguration();

export class QUnfreezeEquipmentConfigurationResponse extends QCommandResponse {
}

export const qUnfreezeEquipmentConfigurationResponse = new QUnfreezeEquipmentConfigurationResponse();

export class QUnfreezeEquipmentConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnfreezeEquipmentConfiguration = new QUnfreezeEquipmentConfiguration();

export class QDeleteEquipmentTypeResponse extends QCommandResponse {
}

export const qDeleteEquipmentTypeResponse = new QDeleteEquipmentTypeResponse();

export class QDeleteEquipmentType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentType = new QDeleteEquipmentType();

export class QFreezeEquipmentResponse extends QCommandResponse {
}

export const qFreezeEquipmentResponse = new QFreezeEquipmentResponse();

export class QFreezeEquipment extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
}

export const qFreezeEquipment = new QFreezeEquipment();

export class QAssociateEquipmentGroupConfigurationsWithEquipmentConfigurationResponse extends QCommandResponse {
}

export const qAssociateEquipmentGroupConfigurationsWithEquipmentConfigurationResponse = new QAssociateEquipmentGroupConfigurationsWithEquipmentConfigurationResponse();

export class QAssociateEquipmentGroupConfigurationsWithEquipmentConfiguration extends QueryObject {
    public readonly EquipmentGroupConfigurationIds = new QCollectionPath(this.withPrefix("EquipmentGroupConfigurationIds"), () => QGuidCollection);
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
}

export const qAssociateEquipmentGroupConfigurationsWithEquipmentConfiguration = new QAssociateEquipmentGroupConfigurationsWithEquipmentConfiguration();

export class QCreateEquipmentConfigurationByDefaultEquipmentTypeResponse extends QCommandResponse {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
}

export const qCreateEquipmentConfigurationByDefaultEquipmentTypeResponse = new QCreateEquipmentConfigurationByDefaultEquipmentTypeResponse();

export class QCreateEquipmentConfigurationByDefaultEquipmentType extends QueryObject {
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Properties = new QEntityCollectionPath(this.withPrefix("Properties"), () => QPropertyWithAttributesParameterType);
}

export const qCreateEquipmentConfigurationByDefaultEquipmentType = new QCreateEquipmentConfigurationByDefaultEquipmentType();

export class QUpdateEquipmentPropertyResponse extends QCommandResponse {
}

export const qUpdateEquipmentPropertyResponse = new QUpdateEquipmentPropertyResponse();

export class QUpdateEquipmentProperty extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly EquipmentConfigurationPropertyNId = new QStringPath(this.withPrefix("EquipmentConfigurationPropertyNId"));
    public readonly EquipmentConfigurationPropertyValue = new QStringPath(this.withPrefix("EquipmentConfigurationPropertyValue"));
    public readonly EquipmentConfigurationPropertyOperational = new QBooleanPath(this.withPrefix("EquipmentConfigurationPropertyOperational"));
}

export const qUpdateEquipmentProperty = new QUpdateEquipmentProperty();

export class QUpdateEquipmentGroupConfigurationResponse extends QCommandResponse {
}

export const qUpdateEquipmentGroupConfigurationResponse = new QUpdateEquipmentGroupConfigurationResponse();

export class QUpdateEquipmentGroupConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly Category = new QStringPath(this.withPrefix("Category"));
}

export const qUpdateEquipmentGroupConfiguration = new QUpdateEquipmentGroupConfiguration();

export class QDeleteEquipmentConfigurationPropertyAttributeResponse extends QCommandResponse {
}

export const qDeleteEquipmentConfigurationPropertyAttributeResponse = new QDeleteEquipmentConfigurationPropertyAttributeResponse();

export class QDeleteEquipmentConfigurationPropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentConfigurationPropertyAttribute = new QDeleteEquipmentConfigurationPropertyAttribute();

export class QDeleteEquipmentConfigurationStateMachineResponse extends QCommandResponse {
}

export const qDeleteEquipmentConfigurationStateMachineResponse = new QDeleteEquipmentConfigurationStateMachineResponse();

export class QDeleteEquipmentConfigurationStateMachine extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly EquipmentConfigurationStateMachineId = new QGuidPath(this.withPrefix("EquipmentConfigurationStateMachineId"));
}

export const qDeleteEquipmentConfigurationStateMachine = new QDeleteEquipmentConfigurationStateMachine();

export class QDeleteEquipmentGraphConfigurationResponse extends QCommandResponse {
}

export const qDeleteEquipmentGraphConfigurationResponse = new QDeleteEquipmentGraphConfigurationResponse();

export class QDeleteEquipmentGraphConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentGraphConfiguration = new QDeleteEquipmentGraphConfiguration();

export class QDeleteEquipmentResponse extends QCommandResponse {
}

export const qDeleteEquipmentResponse = new QDeleteEquipmentResponse();

export class QDeleteEquipment extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly EquipmentConfigurationNId = new QStringPath(this.withPrefix("EquipmentConfigurationNId"));
}

export const qDeleteEquipment = new QDeleteEquipment();

export class QFreezeEquipmentGroupConfigurationResponse extends QCommandResponse {
}

export const qFreezeEquipmentGroupConfigurationResponse = new QFreezeEquipmentGroupConfigurationResponse();

export class QFreezeEquipmentGroupConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qFreezeEquipmentGroupConfiguration = new QFreezeEquipmentGroupConfiguration();

export class QDeleteEquipmentGraphLinkConfigurationResponse extends QCommandResponse {
}

export const qDeleteEquipmentGraphLinkConfigurationResponse = new QDeleteEquipmentGraphLinkConfigurationResponse();

export class QDeleteEquipmentGraphLinkConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentGraphLinkConfiguration = new QDeleteEquipmentGraphLinkConfiguration();

export class QDeleteEquipmentPropertyAttributeResponse extends QCommandResponse {
}

export const qDeleteEquipmentPropertyAttributeResponse = new QDeleteEquipmentPropertyAttributeResponse();

export class QDeleteEquipmentPropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentPropertyAttribute = new QDeleteEquipmentPropertyAttribute();

export class QDeleteEquipmentConfigurationResponse extends QCommandResponse {
}

export const qDeleteEquipmentConfigurationResponse = new QDeleteEquipmentConfigurationResponse();

export class QDeleteEquipmentConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentConfiguration = new QDeleteEquipmentConfiguration();

export class QDeleteEquipmentConfigurationPropertyResponse extends QCommandResponse {
}

export const qDeleteEquipmentConfigurationPropertyResponse = new QDeleteEquipmentConfigurationPropertyResponse();

export class QDeleteEquipmentConfigurationProperty extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentConfigurationProperty = new QDeleteEquipmentConfigurationProperty();

export class QUnfreezeEquipmentTypeResponse extends QCommandResponse {
}

export const qUnfreezeEquipmentTypeResponse = new QUnfreezeEquipmentTypeResponse();

export class QUnfreezeEquipmentType extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qUnfreezeEquipmentType = new QUnfreezeEquipmentType();

export class QDisassociateChildrenEquipmentGroupConfFromEquipmentGroupConfResponse extends QCommandResponse {
}

export const qDisassociateChildrenEquipmentGroupConfFromEquipmentGroupConfResponse = new QDisassociateChildrenEquipmentGroupConfFromEquipmentGroupConfResponse();

export class QDisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf extends QueryObject {
    public readonly EquipmentGroupConfId = new QGuidPath(this.withPrefix("EquipmentGroupConfId"));
    public readonly ChildEquipmentGroupConfIds = new QCollectionPath(this.withPrefix("ChildEquipmentGroupConfIds"), () => QGuidCollection);
}

export const qDisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf = new QDisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf();

export class QUpdateEquipmentConfigurationPropertyAttributeResponse extends QCommandResponse {
}

export const qUpdateEquipmentConfigurationPropertyAttributeResponse = new QUpdateEquipmentConfigurationPropertyAttributeResponse();

export class QUpdateEquipmentConfigurationPropertyAttribute extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
    public readonly AttributeValue = new QStringPath(this.withPrefix("AttributeValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qUpdateEquipmentConfigurationPropertyAttribute = new QUpdateEquipmentConfigurationPropertyAttribute();

export class QUnfreezeEquipmentResponse extends QCommandResponse {
}

export const qUnfreezeEquipmentResponse = new QUnfreezeEquipmentResponse();

export class QUnfreezeEquipment extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
}

export const qUnfreezeEquipment = new QUnfreezeEquipment();

export class QDeleteEquipmentGraphNodeConfigurationResponse extends QCommandResponse {
}

export const qDeleteEquipmentGraphNodeConfigurationResponse = new QDeleteEquipmentGraphNodeConfigurationResponse();

export class QDeleteEquipmentGraphNodeConfiguration extends QueryObject {
    public readonly Id = new QGuidPath(this.withPrefix("Id"));
}

export const qDeleteEquipmentGraphNodeConfiguration = new QDeleteEquipmentGraphNodeConfiguration();

export class QSetEquipmentGraphConfigurationAsDefaultResponse extends QCommandResponse {
}

export const qSetEquipmentGraphConfigurationAsDefaultResponse = new QSetEquipmentGraphConfigurationAsDefaultResponse();

export class QSetEquipmentGraphConfigurationAsDefault extends QueryObject {
    public readonly EquipGraphConfId = new QGuidPath(this.withPrefix("EquipGraphConfId"));
}

export const qSetEquipmentGraphConfigurationAsDefault = new QSetEquipmentGraphConfigurationAsDefault();

export class QEquipmentGraphNodeConfigurationParameterType extends QueryObject {
    public readonly Id = new QStringPath(this.withPrefix("Id"));
    public readonly EquipmentConfigurationNId = new QStringPath(this.withPrefix("EquipmentConfigurationNId"));
    public readonly EquipmentGroupConfigurationNId = new QStringPath(this.withPrefix("EquipmentGroupConfigurationNId"));
    public readonly OffsetX = new QNumberPath(this.withPrefix("OffsetX"));
    public readonly OffsetY = new QNumberPath(this.withPrefix("OffsetY"));
    public readonly ToBeDeleted = new QBooleanPath(this.withPrefix("ToBeDeleted"));
}

export const qEquipmentGraphNodeConfigurationParameterType = new QEquipmentGraphNodeConfigurationParameterType();

export class QEquipmentGraphLinkConfigurationParameterType extends QueryObject {
    public readonly SourceId = new QStringPath(this.withPrefix("SourceId"));
    public readonly DestinationId = new QStringPath(this.withPrefix("DestinationId"));
    public readonly Label = new QStringPath(this.withPrefix("Label"));
    public readonly Id = new QStringPath(this.withPrefix("Id"));
    public readonly SourcePosition = new QStringPath(this.withPrefix("SourcePosition"));
    public readonly DestinationPosition = new QStringPath(this.withPrefix("DestinationPosition"));
    public readonly ToBeDeleted = new QBooleanPath(this.withPrefix("ToBeDeleted"));
}

export const qEquipmentGraphLinkConfigurationParameterType = new QEquipmentGraphLinkConfigurationParameterType();

export class QPropertyParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qPropertyParameterType = new QPropertyParameterType();

export class QPropertyWithAttributesParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly PropertyType = new QEnumPath(this.withPrefix("PropertyType"), SupportedTypes);
    public readonly PropertyValue = new QStringPath(this.withPrefix("PropertyValue"));
    public readonly Attributes = new QEntityCollectionPath(this.withPrefix("Attributes"), () => QPropertyParameterType);
    public readonly Operational = new QBooleanPath(this.withPrefix("Operational"));
}

export const qPropertyWithAttributesParameterType = new QPropertyWithAttributesParameterType();

export class QOPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodesResponse extends QCommandResponse {
}

export const qOPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodesResponse = new QOPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodesResponse();

export class QOPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes extends QueryObject {
}

export const qOPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes = new QOPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes();

export class QOPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfigurationResponse extends QCommandResponse {
}

export const qOPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfigurationResponse = new QOPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfigurationResponse();

export class QOPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly AutomationNodeInstanceNIds = new QCollectionPath(this.withPrefix("AutomationNodeInstanceNIds"), () => QStringCollection);
}

export const qOPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration = new QOPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration();

export class QOPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfigurationResponse extends QCommandResponse {
}

export const qOPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfigurationResponse = new QOPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfigurationResponse();

export class QOPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration extends QueryObject {
    public readonly EquipmentConfigurationId = new QGuidPath(this.withPrefix("EquipmentConfigurationId"));
    public readonly AutomationNodeInstanceNIds = new QCollectionPath(this.withPrefix("AutomationNodeInstanceNIds"), () => QStringCollection);
}

export const qOPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration = new QOPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration();

export class QOPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentTypeResponse extends QCommandResponse {
}

export const qOPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentTypeResponse = new QOPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentTypeResponse();

export class QOPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType extends QueryObject {
    public readonly EquipmentTypeId = new QGuidPath(this.withPrefix("EquipmentTypeId"));
    public readonly AutomationNodeTypeNIds = new QCollectionPath(this.withPrefix("AutomationNodeTypeNIds"), () => QStringCollection);
}

export const qOPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType = new QOPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType();

export class QOPCUAConnect_AssociateAutomationNodeTypesWithEquipmentTypeResponse extends QCommandResponse {
}

export const qOPCUAConnect_AssociateAutomationNodeTypesWithEquipmentTypeResponse = new QOPCUAConnect_AssociateAutomationNodeTypesWithEquipmentTypeResponse();

export class QOPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType extends QueryObject {
    public readonly EquipmentTypeId = new QGuidPath(this.withPrefix("EquipmentTypeId"));
    public readonly AutomationNodeTypeNIds = new QCollectionPath(this.withPrefix("AutomationNodeTypeNIds"), () => QStringCollection);
}

export const qOPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType = new QOPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType();

export class QRF_GetEquipmentHierarchyResponse extends QueryObject {
    public readonly EquipmentHierarchy = new QStringPath(this.withPrefix("EquipmentHierarchy"));
    public readonly EquipmentNIds = new QCollectionPath(this.withPrefix("EquipmentNIds"), () => QStringCollection);
}

export const qRF_GetEquipmentHierarchyResponse = new QRF_GetEquipmentHierarchyResponse();

export class QRF_GetEquipmentHierarchy extends QueryObject {
    public readonly EquipmentGraphConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphConfigurationId"));
    public readonly ParentEquipmentNodeNId = new QStringPath(this.withPrefix("ParentEquipmentNodeNId"));
    public readonly ReturnOneLevel = new QBooleanPath(this.withPrefix("ReturnOneLevel"));
}

export const qRF_GetEquipmentHierarchy = new QRF_GetEquipmentHierarchy();

export class QRF_GetFilteredEquipmentConfigurationListResponse extends QueryObject {
    public readonly EquipmentConfigurationList = new QEntityCollectionPath(this.withPrefix("EquipmentConfigurationList"), () => QEquipmentConfigurationParameterType);
    public readonly EquipmentConfigurationsCount = new QNumberPath(this.withPrefix("EquipmentConfigurationsCount"));
}

export const qRF_GetFilteredEquipmentConfigurationListResponse = new QRF_GetFilteredEquipmentConfigurationListResponse();

export class QRF_GetFilteredEquipmentConfigurationList extends QueryObject {
    public readonly AddedNodesNId = new QCollectionPath(this.withPrefix("AddedNodesNId"), () => QStringCollection);
    public readonly Page = new QNumberPath(this.withPrefix("Page"));
    public readonly ItemsPerPage = new QNumberPath(this.withPrefix("ItemsPerPage"));
    public readonly RemovedNodesNId = new QCollectionPath(this.withPrefix("RemovedNodesNId"), () => QStringCollection);
    public readonly EquipmentGraphConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphConfigurationId"));
    public readonly Filter = new QStringPath(this.withPrefix("Filter"));
}

export const qRF_GetFilteredEquipmentConfigurationList = new QRF_GetFilteredEquipmentConfigurationList();

export class QRF_GetStateMachineListResponse extends QueryObject {
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
}

export const qRF_GetStateMachineListResponse = new QRF_GetStateMachineListResponse();

export class QRF_GetStateMachineList extends QueryObject {
    public readonly EquipmentConfigurationStateMachineId = new QGuidPath(this.withPrefix("EquipmentConfigurationStateMachineId"));
    public readonly EquipmentTypeStateMachineId = new QGuidPath(this.withPrefix("EquipmentTypeStateMachineId"));
}

export const qRF_GetStateMachineList = new QRF_GetStateMachineList();

export class QGetEquipmentConfigurationsWithFilterResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
}

export const qGetEquipmentConfigurationsWithFilterResponse = new QGetEquipmentConfigurationsWithFilterResponse();

export class QGetEquipmentConfigurationsWithFilter extends QueryObject {
    public readonly AddedNodesNId = new QCollectionPath(this.withPrefix("AddedNodesNId"), () => QStringCollection);
    public readonly RemovedNodesNId = new QCollectionPath(this.withPrefix("RemovedNodesNId"), () => QStringCollection);
    public readonly EquipmentGraphConfigurationId = new QGuidPath(this.withPrefix("EquipmentGraphConfigurationId"));
}

export const qGetEquipmentConfigurationsWithFilter = new QGetEquipmentConfigurationsWithFilter();

export class QIQueryable extends QueryObject {
}

export const qIQueryable = new QIQueryable();

export class QEquipmentConfigurationParameterType extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
}

export const qEquipmentConfigurationParameterType = new QEquipmentConfigurationParameterType();

export class QOPCUAConnect_RF_GetAutomationNodesResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly AutomationNodeTypeNId = new QStringPath(this.withPrefix("AutomationNodeTypeNId"));
}

export const qOPCUAConnect_RF_GetAutomationNodesResponse = new QOPCUAConnect_RF_GetAutomationNodesResponse();

export class QOPCUAConnect_RF_GetAutomationNodes extends QueryObject {
    public readonly EquipmentNId = new QStringPath(this.withPrefix("EquipmentNId"));
}

export const qOPCUAConnect_RF_GetAutomationNodes = new QOPCUAConnect_RF_GetAutomationNodes();

export class QOPCUAConnect_RF_GetAutomationNodeTypesResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly IsDeleted = new QBooleanPath(this.withPrefix("IsDeleted"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ActivationStatus = new QEntityPath(this.withPrefix("ActivationStatus"), () => QActivationStatusParameterType);
    public readonly UIStatus = new QStringPath(this.withPrefix("UIStatus"));
    public readonly IsAssociatedToEquipmentType = new QBooleanPath(this.withPrefix("IsAssociatedToEquipmentType"));
}

export const qOPCUAConnect_RF_GetAutomationNodeTypesResponse = new QOPCUAConnect_RF_GetAutomationNodeTypesResponse();

export class QOPCUAConnect_RF_GetAutomationNodeTypes extends QueryObject {
    public readonly EquipmentTypeNId = new QStringPath(this.withPrefix("EquipmentTypeNId"));
    public readonly HideAutomationNodeTypesAssociatedToEquipmentType = new QBooleanPath(this.withPrefix("HideAutomationNodeTypesAssociatedToEquipmentType"));
}

export const qOPCUAConnect_RF_GetAutomationNodeTypes = new QOPCUAConnect_RF_GetAutomationNodeTypes();

export class QOPCUAConnect_RF_GetAutomationNodeInstancesResponse extends QueryObject {
    public readonly NId = new QStringPath(this.withPrefix("NId"));
    public readonly Revision = new QStringPath(this.withPrefix("Revision"));
    public readonly IsCurrent = new QBooleanPath(this.withPrefix("IsCurrent"));
    public readonly IsLocked = new QBooleanPath(this.withPrefix("IsLocked"));
    public readonly IsDeleted = new QBooleanPath(this.withPrefix("IsDeleted"));
    public readonly Name = new QStringPath(this.withPrefix("Name"));
    public readonly Description = new QStringPath(this.withPrefix("Description"));
    public readonly ActivationStatus = new QEntityPath(this.withPrefix("ActivationStatus"), () => QActivationStatusParameterType);
    public readonly UIStatus = new QStringPath(this.withPrefix("UIStatus"));
    public readonly AutomationNodeTypeNId = new QStringPath(this.withPrefix("AutomationNodeTypeNId"));
    public readonly IsAssociatedToEquipmentConfiguration = new QBooleanPath(this.withPrefix("IsAssociatedToEquipmentConfiguration"));
    public readonly IsAssociatedToEquipmentType = new QBooleanPath(this.withPrefix("IsAssociatedToEquipmentType"));
}

export const qOPCUAConnect_RF_GetAutomationNodeInstancesResponse = new QOPCUAConnect_RF_GetAutomationNodeInstancesResponse();

export class QOPCUAConnect_RF_GetAutomationNodeInstances extends QueryObject {
    public readonly EquipmentConfigurationNId = new QStringPath(this.withPrefix("EquipmentConfigurationNId"));
    public readonly HideAutomationNodeInstancesAssociatedToEquipmentConfiguration = new QBooleanPath(this.withPrefix("HideAutomationNodeInstancesAssociatedToEquipmentConfiguration"));
    public readonly FilterByEquipmentType = new QBooleanPath(this.withPrefix("FilterByEquipmentType"));
}

export const qOPCUAConnect_RF_GetAutomationNodeInstances = new QOPCUAConnect_RF_GetAutomationNodeInstances();

export class QActivationStatusParameterType extends QueryObject {
    public readonly Dirty = new QBooleanPath(this.withPrefix("Dirty"));
    public readonly Activated = new QBooleanPath(this.withPrefix("Activated"));
    public readonly Ready = new QBooleanPath(this.withPrefix("Ready"));
    public readonly Dismissed = new QBooleanPath(this.withPrefix("Dismissed"));
    public readonly ConfirmedOn = new QDateTimeOffsetPath(this.withPrefix("ConfirmedOn"));
}

export const qActivationStatusParameterType = new QActivationStatusParameterType();

export class QBaseResponse extends QCommandResponse {
}

export const qBaseResponse = new QBaseResponse();

export class QActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types extends QueryObject {
    public readonly Dirty = new QBooleanPath(this.withPrefix("Dirty"));
    public readonly Activated = new QBooleanPath(this.withPrefix("Activated"));
    public readonly Ready = new QBooleanPath(this.withPrefix("Ready"));
    public readonly Dismissed = new QBooleanPath(this.withPrefix("Dismissed"));
    public readonly ConfirmedOn = new QDateTimeOffsetPath(this.withPrefix("ConfirmedOn"));
}

export const qActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types = new QActivationStatus_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types();

export class QTagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types extends QueryObject {
    public readonly ChannelNId = new QStringPath(this.withPrefix("ChannelNId"));
    public readonly Address = new QStringPath(this.withPrefix("Address"));
    public readonly AcquisitionCycleNId = new QStringPath(this.withPrefix("AcquisitionCycleNId"));
    public readonly DeltaValue = new QNumberPath(this.withPrefix("DeltaValue"));
    public readonly SmoothingMode = new QEnumPath(this.withPrefix("SmoothingMode"), TagSmoothingMode);
    public readonly AcquisitionMode = new QEnumPath(this.withPrefix("AcquisitionMode"), TagAcquisitionMode);
    public readonly AddressType = new QEnumPath(this.withPrefix("AddressType"), TagAddressType);
    public readonly Delta = new QNumberPath(this.withPrefix("Delta"));
}

export const qTagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types = new QTagAspectType_Siemens_SimaticIT_MasterData_ATN_MS_MSModel_Types();

export class QQuantityType extends QueryObject {
    public readonly UoMNId = new QStringPath(this.withPrefix("UoMNId"));
    public readonly QuantityValue = new QNumberPath(this.withPrefix("QuantityValue"));
}

export const qQuantityType = new QQuantityType();

export class QStatusType extends QueryObject {
    public readonly StateMachineNId = new QStringPath(this.withPrefix("StateMachineNId"));
    public readonly StatusNId = new QStringPath(this.withPrefix("StatusNId"));
}

export const qStatusType = new QStatusType();

export class QRF_GetEquipmentHierarchy2 extends QFunction<RF_GetEquipmentHierarchy2Params> {
    private readonly params = [new QComplexParam("function", new QRF_GetEquipmentHierarchy())];

    constructor() {
        super("RF_GetEquipmentHierarchy", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QRF_GetFilteredEquipmentConfigurationList2 extends QFunction<RF_GetFilteredEquipmentConfigurationList2Params> {
    private readonly params = [new QComplexParam("function", new QRF_GetFilteredEquipmentConfigurationList())];

    constructor() {
        super("RF_GetFilteredEquipmentConfigurationList", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QRF_GetStateMachineList2 extends QFunction<RF_GetStateMachineList2Params> {
    private readonly params = [new QComplexParam("function", new QRF_GetStateMachineList())];

    constructor() {
        super("RF_GetStateMachineList", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_RF_GetAutomationNodes2 extends QFunction<OPCUAConnect_RF_GetAutomationNodes2Params> {
    private readonly params = [new QComplexParam("function", new QOPCUAConnect_RF_GetAutomationNodes())];

    constructor() {
        super("OPCUAConnect_RF_GetAutomationNodes", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QGetEquipmentConfigurationsWithFilter2 extends QFunction<GetEquipmentConfigurationsWithFilter2Params> {
    private readonly params = [new QComplexParam("function", new QGetEquipmentConfigurationsWithFilter())];

    constructor() {
        super("GetEquipmentConfigurationsWithFilter", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_RF_GetAutomationNodeTypes2 extends QFunction<OPCUAConnect_RF_GetAutomationNodeTypes2Params> {
    private readonly params = [new QComplexParam("function", new QOPCUAConnect_RF_GetAutomationNodeTypes())];

    constructor() {
        super("OPCUAConnect_RF_GetAutomationNodeTypes", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_RF_GetAutomationNodeInstances2 extends QFunction<OPCUAConnect_RF_GetAutomationNodeInstances2Params> {
    private readonly params = [new QComplexParam("function", new QOPCUAConnect_RF_GetAutomationNodeInstances())];

    constructor() {
        super("OPCUAConnect_RF_GetAutomationNodeInstances", new OperationReturnType(ReturnTypes.COMPLEX_COLLECTION, new QComplexParam("NONE", new QIQueryable)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentLevels2 extends QAction<DeleteEquipmentLevels2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentLevels())];

    constructor() {
        super("DeleteEquipmentLevels", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentLevelsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentTypes2 extends QAction<DeleteEquipmentTypes2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentTypes())];

    constructor() {
        super("DeleteEquipmentTypes", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentTypesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentConfigurations2 extends QAction<DeleteEquipmentConfigurations2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentConfigurations())];

    constructor() {
        super("DeleteEquipmentConfigurations", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentConfigurationsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGroupConfigurations2 extends QAction<DeleteEquipmentGroupConfigurations2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGroupConfigurations())];

    constructor() {
        super("DeleteEquipmentGroupConfigurations", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGroupConfigurationsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGraphConfigurations2 extends QAction<DeleteEquipmentGraphConfigurations2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGraphConfigurations())];

    constructor() {
        super("DeleteEquipmentGraphConfigurations", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGraphConfigurationsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGraphConfiguration2 extends QAction<UpdateEquipmentGraphConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGraphConfiguration())];

    constructor() {
        super("UpdateEquipmentGraphConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGraphConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssociateChildrenEquipmentGroupConfWithEquipmentGroupConf2 extends QAction<AssociateChildrenEquipmentGroupConfWithEquipmentGroupConf2Params> {
    private readonly params = [new QComplexParam("command", new QAssociateChildrenEquipmentGroupConfWithEquipmentGroupConf())];

    constructor() {
        super("AssociateChildrenEquipmentGroupConfWithEquipmentGroupConf", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssociateChildrenEquipmentGroupConfWithEquipmentGroupConfResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssociateEquipmentConfigurationsWithEquipmentGroupConfiguration2 extends QAction<AssociateEquipmentConfigurationsWithEquipmentGroupConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QAssociateEquipmentConfigurationsWithEquipmentGroupConfiguration())];

    constructor() {
        super("AssociateEquipmentConfigurationsWithEquipmentGroupConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssociateEquipmentConfigurationsWithEquipmentGroupConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSynchronizeEquipmentGraph2 extends QAction<SynchronizeEquipmentGraph2Params> {
    private readonly params = [new QComplexParam("command", new QSynchronizeEquipmentGraph())];

    constructor() {
        super("SynchronizeEquipmentGraph", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSynchronizeEquipmentGraphResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QBulkImportEquipmentGraphConfiguration2 extends QAction<BulkImportEquipmentGraphConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QBulkImportEquipmentGraphConfiguration())];

    constructor() {
        super("BulkImportEquipmentGraphConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QBulkImportEquipmentGraphConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAddEquipmentTypeStateMachines2 extends QAction<AddEquipmentTypeStateMachines2Params> {
    private readonly params = [new QComplexParam("command", new QAddEquipmentTypeStateMachines())];

    constructor() {
        super("AddEquipmentTypeStateMachines", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAddEquipmentTypeStateMachinesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentStateMachines2 extends QAction<CreateEquipmentStateMachines2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentStateMachines())];

    constructor() {
        super("CreateEquipmentStateMachines", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentStateMachinesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentTypePropertyAttribute2 extends QAction<DeleteEquipmentTypePropertyAttribute2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentTypePropertyAttribute())];

    constructor() {
        super("DeleteEquipmentTypePropertyAttribute", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentTypePropertyAttributeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentPropertyAttribute2 extends QAction<UpdateEquipmentPropertyAttribute2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentPropertyAttribute())];

    constructor() {
        super("UpdateEquipmentPropertyAttribute", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentPropertyAttributeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetEquipmentPropertyValue2 extends QAction<SetEquipmentPropertyValue2Params> {
    private readonly params = [new QComplexParam("command", new QSetEquipmentPropertyValue())];

    constructor() {
        super("SetEquipmentPropertyValue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetEquipmentPropertyValueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnfreezeEquipmentLevel2 extends QAction<UnfreezeEquipmentLevel2Params> {
    private readonly params = [new QComplexParam("command", new QUnfreezeEquipmentLevel())];

    constructor() {
        super("UnfreezeEquipmentLevel", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnfreezeEquipmentLevelResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QFreezeEquipmentType2 extends QAction<FreezeEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QFreezeEquipmentType())];

    constructor() {
        super("FreezeEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QFreezeEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGraphNode2 extends QAction<UpdateEquipmentGraphNode2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGraphNode())];

    constructor() {
        super("UpdateEquipmentGraphNode", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGraphNodeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGraphLink2 extends QAction<UpdateEquipmentGraphLink2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGraphLink())];

    constructor() {
        super("UpdateEquipmentGraphLink", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGraphLinkResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGroupConfiguration2 extends QAction<DeleteEquipmentGroupConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGroupConfiguration())];

    constructor() {
        super("DeleteEquipmentGroupConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGroupConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDisassociateParentsEquipmentGroupConfFromEquipmentGroupConf2 extends QAction<DisassociateParentsEquipmentGroupConfFromEquipmentGroupConf2Params> {
    private readonly params = [new QComplexParam("command", new QDisassociateParentsEquipmentGroupConfFromEquipmentGroupConf())];

    constructor() {
        super("DisassociateParentsEquipmentGroupConfFromEquipmentGroupConf", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDisassociateParentsEquipmentGroupConfFromEquipmentGroupConfResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentTypeProperty2 extends QAction<DeleteEquipmentTypeProperty2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentTypeProperty())];

    constructor() {
        super("DeleteEquipmentTypeProperty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentTypePropertyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssociateParentsEquipmentGroupConfWithEquipmentGroupConf2 extends QAction<AssociateParentsEquipmentGroupConfWithEquipmentGroupConf2Params> {
    private readonly params = [new QComplexParam("command", new QAssociateParentsEquipmentGroupConfWithEquipmentGroupConf())];

    constructor() {
        super("AssociateParentsEquipmentGroupConfWithEquipmentGroupConf", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssociateParentsEquipmentGroupConfWithEquipmentGroupConfResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentConfiguration2 extends QAction<UpdateEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentConfiguration())];

    constructor() {
        super("UpdateEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipment2 extends QAction<UpdateEquipment2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipment())];

    constructor() {
        super("UpdateEquipment", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration2 extends QAction<DisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration())];

    constructor() {
        super("DisassociateEquipmentGroupConfigurationsFromEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDisassociateEquipmentGroupConfigurationsFromEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAddEquipmentConfigurationStateMachines2 extends QAction<AddEquipmentConfigurationStateMachines2Params> {
    private readonly params = [new QComplexParam("command", new QAddEquipmentConfigurationStateMachines())];

    constructor() {
        super("AddEquipmentConfigurationStateMachines", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAddEquipmentConfigurationStateMachinesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration2 extends QAction<DisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration())];

    constructor() {
        super("DisassociateEquipmentConfigurationsFromEquipmentGroupConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDisassociateEquipmentConfigurationsFromEquipmentGroupConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetEquipmentTypeAsDefault2 extends QAction<SetEquipmentTypeAsDefault2Params> {
    private readonly params = [new QComplexParam("command", new QSetEquipmentTypeAsDefault())];

    constructor() {
        super("SetEquipmentTypeAsDefault", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetEquipmentTypeAsDefaultResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetEquipmentStatus2 extends QAction<SetEquipmentStatus2Params> {
    private readonly params = [new QComplexParam("command", new QSetEquipmentStatus())];

    constructor() {
        super("SetEquipmentStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetEquipmentStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QFreezeEquipmentLevel2 extends QAction<FreezeEquipmentLevel2Params> {
    private readonly params = [new QComplexParam("command", new QFreezeEquipmentLevel())];

    constructor() {
        super("FreezeEquipmentLevel", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QFreezeEquipmentLevelResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentStateMachine2 extends QAction<DeleteEquipmentStateMachine2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentStateMachine())];

    constructor() {
        super("DeleteEquipmentStateMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentStateMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentType2 extends QAction<UpdateEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentType())];

    constructor() {
        super("UpdateEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGraphType2 extends QAction<UpdateEquipmentGraphType2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGraphType())];

    constructor() {
        super("UpdateEquipmentGraphType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGraphTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateHierarchyEquipmentNodeConfiguration2 extends QAction<UpdateHierarchyEquipmentNodeConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateHierarchyEquipmentNodeConfiguration())];

    constructor() {
        super("UpdateHierarchyEquipmentNodeConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateHierarchyEquipmentNodeConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentLevel2 extends QAction<CreateEquipmentLevel2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentLevel())];

    constructor() {
        super("CreateEquipmentLevel", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentLevelResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentGroupConfiguration2 extends QAction<CreateEquipmentGroupConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentGroupConfiguration())];

    constructor() {
        super("CreateEquipmentGroupConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentGroupConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSynchronizeEquipment2 extends QAction<SynchronizeEquipment2Params> {
    private readonly params = [new QComplexParam("command", new QSynchronizeEquipment())];

    constructor() {
        super("SynchronizeEquipment", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSynchronizeEquipmentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipment2 extends QAction<CreateEquipment2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipment())];

    constructor() {
        super("CreateEquipment", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentTypeProperty2 extends QAction<UpdateEquipmentTypeProperty2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentTypeProperty())];

    constructor() {
        super("UpdateEquipmentTypeProperty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentTypePropertyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentConfigurationProperty2 extends QAction<UpdateEquipmentConfigurationProperty2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentConfigurationProperty())];

    constructor() {
        super("UpdateEquipmentConfigurationProperty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentConfigurationPropertyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnfreezeEquipmentGroupConfiguration2 extends QAction<UnfreezeEquipmentGroupConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUnfreezeEquipmentGroupConfiguration())];

    constructor() {
        super("UnfreezeEquipmentGroupConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnfreezeEquipmentGroupConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentGraphNodeConfiguration2 extends QAction<CreateEquipmentGraphNodeConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentGraphNodeConfiguration())];

    constructor() {
        super("CreateEquipmentGraphNodeConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentGraphNodeConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentGraphType2 extends QAction<CreateEquipmentGraphType2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentGraphType())];

    constructor() {
        super("CreateEquipmentGraphType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentGraphTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGraphType2 extends QAction<DeleteEquipmentGraphType2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGraphType())];

    constructor() {
        super("DeleteEquipmentGraphType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGraphTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentLevel2 extends QAction<UpdateEquipmentLevel2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentLevel())];

    constructor() {
        super("UpdateEquipmentLevel", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentLevelResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentTypePropertyAttribute2 extends QAction<UpdateEquipmentTypePropertyAttribute2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentTypePropertyAttribute())];

    constructor() {
        super("UpdateEquipmentTypePropertyAttribute", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentTypePropertyAttributeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentType2 extends QAction<CreateEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentType())];

    constructor() {
        super("CreateEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentConfiguration2 extends QAction<CreateEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentConfiguration())];

    constructor() {
        super("CreateEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGraphLinkConfiguration2 extends QAction<UpdateEquipmentGraphLinkConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGraphLinkConfiguration())];

    constructor() {
        super("UpdateEquipmentGraphLinkConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGraphLinkConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QBulkImportEquipmentHierarchy2 extends QAction<BulkImportEquipmentHierarchy2Params> {
    private readonly params = [new QComplexParam("command", new QBulkImportEquipmentHierarchy())];

    constructor() {
        super("BulkImportEquipmentHierarchy", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QBulkImportEquipmentHierarchyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QForceEquipmentStatus2 extends QAction<ForceEquipmentStatus2Params> {
    private readonly params = [new QComplexParam("command", new QForceEquipmentStatus())];

    constructor() {
        super("ForceEquipmentStatus", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QForceEquipmentStatusResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetEquipmentPropertyAttributeValue2 extends QAction<SetEquipmentPropertyAttributeValue2Params> {
    private readonly params = [new QComplexParam("command", new QSetEquipmentPropertyAttributeValue())];

    constructor() {
        super("SetEquipmentPropertyAttributeValue", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetEquipmentPropertyAttributeValueResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentLevel2 extends QAction<DeleteEquipmentLevel2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentLevel())];

    constructor() {
        super("DeleteEquipmentLevel", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentLevelResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentGraphLinkConfiguration2 extends QAction<CreateEquipmentGraphLinkConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentGraphLinkConfiguration())];

    constructor() {
        super("CreateEquipmentGraphLinkConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentGraphLinkConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QFreezeEquipmentConfiguration2 extends QAction<FreezeEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QFreezeEquipmentConfiguration())];

    constructor() {
        super("FreezeEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QFreezeEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteHierarchyEquipmentNodeConfiguration2 extends QAction<DeleteHierarchyEquipmentNodeConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteHierarchyEquipmentNodeConfiguration())];

    constructor() {
        super("DeleteHierarchyEquipmentNodeConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteHierarchyEquipmentNodeConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGroup2 extends QAction<UpdateEquipmentGroup2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGroup())];

    constructor() {
        super("UpdateEquipmentGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateHierarchyEquipmentNodeConfigurations2 extends QAction<CreateHierarchyEquipmentNodeConfigurations2Params> {
    private readonly params = [new QComplexParam("command", new QCreateHierarchyEquipmentNodeConfigurations())];

    constructor() {
        super("CreateHierarchyEquipmentNodeConfigurations", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateHierarchyEquipmentNodeConfigurationsResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSynchronizeEquipmentGroup2 extends QAction<SynchronizeEquipmentGroup2Params> {
    private readonly params = [new QComplexParam("command", new QSynchronizeEquipmentGroup())];

    constructor() {
        super("SynchronizeEquipmentGroup", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSynchronizeEquipmentGroupResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentTypeStateMachine2 extends QAction<DeleteEquipmentTypeStateMachine2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentTypeStateMachine())];

    constructor() {
        super("DeleteEquipmentTypeStateMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentTypeStateMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentGraphConfiguration2 extends QAction<CreateEquipmentGraphConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentGraphConfiguration())];

    constructor() {
        super("CreateEquipmentGraphConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentGraphConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnfreezeEquipmentConfiguration2 extends QAction<UnfreezeEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUnfreezeEquipmentConfiguration())];

    constructor() {
        super("UnfreezeEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnfreezeEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentType2 extends QAction<DeleteEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentType())];

    constructor() {
        super("DeleteEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QFreezeEquipment2 extends QAction<FreezeEquipment2Params> {
    private readonly params = [new QComplexParam("command", new QFreezeEquipment())];

    constructor() {
        super("FreezeEquipment", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QFreezeEquipmentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QAssociateEquipmentGroupConfigurationsWithEquipmentConfiguration2 extends QAction<AssociateEquipmentGroupConfigurationsWithEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QAssociateEquipmentGroupConfigurationsWithEquipmentConfiguration())];

    constructor() {
        super("AssociateEquipmentGroupConfigurationsWithEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QAssociateEquipmentGroupConfigurationsWithEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QCreateEquipmentConfigurationByDefaultEquipmentType2 extends QAction<CreateEquipmentConfigurationByDefaultEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QCreateEquipmentConfigurationByDefaultEquipmentType())];

    constructor() {
        super("CreateEquipmentConfigurationByDefaultEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QCreateEquipmentConfigurationByDefaultEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentProperty2 extends QAction<UpdateEquipmentProperty2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentProperty())];

    constructor() {
        super("UpdateEquipmentProperty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentPropertyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentGroupConfiguration2 extends QAction<UpdateEquipmentGroupConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentGroupConfiguration())];

    constructor() {
        super("UpdateEquipmentGroupConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentGroupConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentConfigurationPropertyAttribute2 extends QAction<DeleteEquipmentConfigurationPropertyAttribute2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentConfigurationPropertyAttribute())];

    constructor() {
        super("DeleteEquipmentConfigurationPropertyAttribute", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentConfigurationPropertyAttributeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentConfigurationStateMachine2 extends QAction<DeleteEquipmentConfigurationStateMachine2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentConfigurationStateMachine())];

    constructor() {
        super("DeleteEquipmentConfigurationStateMachine", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentConfigurationStateMachineResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGraphConfiguration2 extends QAction<DeleteEquipmentGraphConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGraphConfiguration())];

    constructor() {
        super("DeleteEquipmentGraphConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGraphConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipment2 extends QAction<DeleteEquipment2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipment())];

    constructor() {
        super("DeleteEquipment", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QFreezeEquipmentGroupConfiguration2 extends QAction<FreezeEquipmentGroupConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QFreezeEquipmentGroupConfiguration())];

    constructor() {
        super("FreezeEquipmentGroupConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QFreezeEquipmentGroupConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGraphLinkConfiguration2 extends QAction<DeleteEquipmentGraphLinkConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGraphLinkConfiguration())];

    constructor() {
        super("DeleteEquipmentGraphLinkConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGraphLinkConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentPropertyAttribute2 extends QAction<DeleteEquipmentPropertyAttribute2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentPropertyAttribute())];

    constructor() {
        super("DeleteEquipmentPropertyAttribute", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentPropertyAttributeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentConfiguration2 extends QAction<DeleteEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentConfiguration())];

    constructor() {
        super("DeleteEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentConfigurationProperty2 extends QAction<DeleteEquipmentConfigurationProperty2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentConfigurationProperty())];

    constructor() {
        super("DeleteEquipmentConfigurationProperty", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentConfigurationPropertyResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnfreezeEquipmentType2 extends QAction<UnfreezeEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QUnfreezeEquipmentType())];

    constructor() {
        super("UnfreezeEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnfreezeEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf2 extends QAction<DisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf2Params> {
    private readonly params = [new QComplexParam("command", new QDisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf())];

    constructor() {
        super("DisassociateChildrenEquipmentGroupConfFromEquipmentGroupConf", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDisassociateChildrenEquipmentGroupConfFromEquipmentGroupConfResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUpdateEquipmentConfigurationPropertyAttribute2 extends QAction<UpdateEquipmentConfigurationPropertyAttribute2Params> {
    private readonly params = [new QComplexParam("command", new QUpdateEquipmentConfigurationPropertyAttribute())];

    constructor() {
        super("UpdateEquipmentConfigurationPropertyAttribute", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUpdateEquipmentConfigurationPropertyAttributeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QUnfreezeEquipment2 extends QAction<UnfreezeEquipment2Params> {
    private readonly params = [new QComplexParam("command", new QUnfreezeEquipment())];

    constructor() {
        super("UnfreezeEquipment", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QUnfreezeEquipmentResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QDeleteEquipmentGraphNodeConfiguration2 extends QAction<DeleteEquipmentGraphNodeConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QDeleteEquipmentGraphNodeConfiguration())];

    constructor() {
        super("DeleteEquipmentGraphNodeConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QDeleteEquipmentGraphNodeConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes2 extends QAction<OPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes2Params> {
    private readonly params = [new QComplexParam("command", new QOPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes())];

    constructor() {
        super("OPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodes", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QOPCUAConnect_SynchronizeAssociationBetweenEquipmentAndAutomationNodesResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration2 extends QAction<OPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QOPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration())];

    constructor() {
        super("OPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QOPCUAConnect_DisassociateAutomationNodeInstancesFromEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration2 extends QAction<OPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration2Params> {
    private readonly params = [new QComplexParam("command", new QOPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration())];

    constructor() {
        super("OPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfiguration", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QOPCUAConnect_AssociateAutomationNodeInstancesWithEquipmentConfigurationResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType2 extends QAction<OPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QOPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType())];

    constructor() {
        super("OPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QOPCUAConnect_DisassociateAutomationNodeTypesFromEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QOPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType2 extends QAction<OPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType2Params> {
    private readonly params = [new QComplexParam("command", new QOPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType())];

    constructor() {
        super("OPCUAConnect_AssociateAutomationNodeTypesWithEquipmentType", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QOPCUAConnect_AssociateAutomationNodeTypesWithEquipmentTypeResponse)))
    }

    getParams() {
        return this.params
    }
}

export class QSetEquipmentGraphConfigurationAsDefault2 extends QAction<SetEquipmentGraphConfigurationAsDefault2Params> {
    private readonly params = [new QComplexParam("command", new QSetEquipmentGraphConfigurationAsDefault())];

    constructor() {
        super("SetEquipmentGraphConfigurationAsDefault", new OperationReturnType(ReturnTypes.COMPLEX, new QComplexParam("NONE", new QSetEquipmentGraphConfigurationAsDefaultResponse)))
    }

    getParams() {
        return this.params
    }
}
